export const layers = {
  additional: [
    {
      type: 'layer',
      id: 'topography',
      name: 'fews_etopo30_v1:etopo30_v1',
      title: 'GTOPO 30 Elevation',
      description:
        'GTOPO30 is a global digital elevation model with a horizontal grid spacing of 30 arc seconds (approximately 1 kilometer) produced by the U.S. Geological Survey\'s Center for Earth Resources Observation and Science (EROS) in 1996. More information can be found <a href ="https://www.usgs.gov/centers/eros/science/usgs-eros-archive-digital-elevation-global-30-arc-second-elevation-gtopo30?qt-science_center_objects=0#qt-science_center_objects">here.</a>',
      exportable: false,
      source: {
        wms: 'https://dmsdata.cr.usgs.gov/geoserver/wms?',
        wcs: 'https://dmsdata.cr.usgs.gov/geoserver/wcs',
        gwc: 'https://dmsdata.cr.usgs.gov/geoserver/gwc/service/wms?',
      },
      display: false,
      loadOnly: false,
      mask: false,
      transparency: true,
      srs: 'EPSG:4326',
      featureInfo: {
        GRAY_INDEX: {
          displayName: 'Pixel Value',
          displayValue: null,
          value: null,
          mapValues: [],
          significantDigits: 2,
        },
      },
      resolution: '0.0083333333',
      style: 'fews_cvtopo_raster_ngviewer',
      legend: {
        style: 'fews_cvtopo_raster_ngviewer_legend',
        customImageURL: null,
        title: 'Topography',
      },
      unit: 'meters',
    },
    {
      type: 'layer',
      id: 'population',
      name: 'fews_landscan_2024:landscan_2024',
      title: 'LandScan Population',
      description:
        'LandScan Global 2024 is a global population distribution data set with approximately 1 km spatial resolution developed by the Oak Ridge National Laboratory for the United States Department of Defense.For more information: <a href="http://landscan.ornl.gov">http://landscan.ornl.gov</a>',
      exportable: false,
      source: {
        wms: 'https://dmsdata.cr.usgs.gov/geoserver/wms?',
        wcs: 'https://dmsdata.cr.usgs.gov/geoserver/wcs',
        gwc: 'https://dmsdata.cr.usgs.gov/geoserver/gwc/service/wms?',
      },
      display: false,
      loadOnly: false,
      mask: false,
      transparency: true,
      srs: 'EPSG:4326',
      featureInfo: {
        GRAY_INDEX: {
          displayName: 'Pixel Value',
          displayValue: null,
          value: null,
          mapValues: [],
          significantDigits: 2,
        },
      },
      resolution: '0.0083333333',
      style: 'fews_landscan_raster_ngviewer',
      legend: {
        style: 'fews_landscan_raster_ngviewer_legend',
        customImageURL: null,
        title: 'Population Landscan',
      },
      unit: '# people/cell',
    },
  ],

  hidden: [
  ],

  overlays: [
    {
      type: 'folder',
      title: 'Dataset',
      expanded: true,
      folder: [
        /*
         * CHIRPS v3.0
         */
        {
          type: 'folder',
          title: 'CHIRPS v3.0 Final',
          description:
            'Climate Hazard group InfraRed Precipitation with Stations version 3.0 time series. CHIRPSv3.0 data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Group (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_data:chirpsv3_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: true,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_data:chirpsv3_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_data:chirpsv3_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_data:chirpsv3_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_data:chirpsv3_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaData4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_data:chirpsv3_global_4_monthly_data',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 4 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_4_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaData5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_data:chirpsv3_global_5_monthly_data',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 5 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_5_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaData6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_data:chirpsv3_global_6_monthly_data',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 6 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_6_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_anom:chirpsv3_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_anom:chirpsv3_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_anom:chirpsv3_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_anom:chirpsv3_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_anom:chirpsv3_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomaly4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_anom:chirpsv3_global_4_monthly_anom',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 4 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_4_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomaly5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_anom:chirpsv3_global_5_monthly_anom',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 5 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_5_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaAnomaly6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_anom:chirpsv3_global_6_monthly_anom',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 6 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_6_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_zscore:chirpsv3_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Zscore (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_pentad_zscore',
                    chartYAxisLabel: 'Zscore (none)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_zscore:chirpsv3_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Zscore (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_dekad_zscore',
                    chartYAxisLabel: 'Zscore (none)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_zscore:chirpsv3_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_zscore:chirpsv3_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_zscore:chirpsv3_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscore4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_zscore:chirpsv3_global_4_monthly_zscore',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 4 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_4_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscore5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_zscore:chirpsv3_global_5_monthly_zscore',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 5 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_5_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3AfricaZscore6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_zscore:chirpsv3_global_6_monthly_zscore',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 6 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_6_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHIRPS Parts Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3partsanomAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3anompart_global_1_monthly_data:chirpsv3anompart_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chirps_anom_parts',
                  legend: {
                    style: 'chirps_anom_parts',
                    customImageURL: null,
                    title: 'CHIRPS Parts Anom v3.0 Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3anompart_global_1_monthly_data',
                    chartYAxisLabel: 'CHIRPS Parts Anom',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHIRPS Parts Anom Weights',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3partsanomwtAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3anomwt_global_1_monthly_data:chirpsv3anomwt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chirps_anom_wt',
                  legend: {
                    style: 'chirps_anom_wt',
                    customImageURL: null,
                    title: 'CHIRPS Parts Anom Weights v3.0 Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3anomwt_global_1_monthly_data',
                    chartYAxisLabel: 'CHIRPS Parts Anom Weights',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Density',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3stndensityAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stndensity_global_1_monthly_data:chirpsv3stndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Density',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stndensity_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 Final',
          description:
            'Climate Hazard group InfraRed Precipitation with Stations version 3.0 time series. CHIRPSv3.0 data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Group (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_data:chirpsv3_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: true,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_data:chirpsv3_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_data:chirpsv3_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_data:chirpsv3_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_data:chirpsv3_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalData4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_data:chirpsv3_global_4_monthly_data',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 4 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_4_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalData5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_data:chirpsv3_global_5_monthly_data',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 5 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_5_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalData6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_data:chirpsv3_global_6_monthly_data',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 6 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_6_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_anom:chirpsv3_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_anom:chirpsv3_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_anom:chirpsv3_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_anom:chirpsv3_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_anom:chirpsv3_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomaly4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_anom:chirpsv3_global_4_monthly_anom',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 4 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_4_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomaly5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_anom:chirpsv3_global_5_monthly_anom',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 5 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_5_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalAnomaly6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_anom:chirpsv3_global_6_monthly_anom',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 6 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_6_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_zscore:chirpsv3_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Zscore (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_pentad_zscore',
                    chartYAxisLabel: 'Zscore (none)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_zscore:chirpsv3_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Zscore (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_dekad_zscore',
                    chartYAxisLabel: 'Zscore (none)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_zscore:chirpsv3_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_zscore:chirpsv3_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_zscore:chirpsv3_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscore4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_zscore:chirpsv3_global_4_monthly_zscore',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 4 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_4_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscore5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_zscore:chirpsv3_global_5_monthly_zscore',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 5 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_5_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3GlobalZscore6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_zscore:chirpsv3_global_6_monthly_zscore',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 6 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_6_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHIRPS Parts Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3partsanomGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3anompart_global_1_monthly_data:chirpsv3anompart_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chirps_anom_parts',
                  legend: {
                    style: 'chirps_anom_parts',
                    customImageURL: null,
                    title: 'CHIRPS Parts Anom v3.0 Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3anompart_global_1_monthly_data',
                    chartYAxisLabel: 'CHIRPS Parts Anom',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHIRPS Parts Anom Weights',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3partsanomwtGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3anomwt_global_1_monthly_data:chirpsv3anomwt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chirps_anom_wt',
                  legend: {
                    style: 'chirps_anom_wt',
                    customImageURL: null,
                    title: 'CHIRPS Parts Anom Weights v3.0 Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3anomwt_global_1_monthly_data',
                    chartYAxisLabel: 'CHIRPS Parts Anom Weights',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Density',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3stndensityGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stndensity_global_1_monthly_data:chirpsv3stndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Density',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stndensity_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 Final',
          description:
            'Climate Hazard group InfraRed Precipitation with Stations version 3.0 time series. CHIRPSv3.0  data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate HazardGroup (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_data:chirpsv3_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: true,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_data:chirpsv3_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_data:chirpsv3_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_data:chirpsv3_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_data:chirpsv3_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarData4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_data:chirpsv3_global_4_monthly_data',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 4 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_4_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarData5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_data:chirpsv3_global_5_monthly_data',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 5 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_5_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarData6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_data:chirpsv3_global_6_monthly_data',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 6 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3_global_6_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_anom:chirpsv3_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_anom:chirpsv3_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_anom:chirpsv3_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_anom:chirpsv3_global_2_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_anom:chirpsv3_global_3_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomaly4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_anom:chirpsv3_global_4_monthly_anom',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 4 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_4_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomaly5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_anom:chirpsv3_global_5_monthly_anom',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 5 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_5_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarAnomaly6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_anom:chirpsv3_global_6_monthly_anom',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.0 6 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3_global_6_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_pentad_zscore:chirpsv3_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Pentadal Zscore (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_pentad_zscore',
                    chartYAxisLabel: 'Zscore (none)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_dekad_zscore:chirpsv3_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Dekadal Zscore (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_dekad_zscore',
                    chartYAxisLabel: 'Zscore (none)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_1_monthly_zscore:chirpsv3_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_2_monthly_zscore:chirpsv3_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_3_monthly_zscore:chirpsv3_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscore4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_4_monthly_zscore:chirpsv3_global_4_monthly_zscore',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 4 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_4_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscore5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_5_monthly_zscore:chirpsv3_global_5_monthly_zscore',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 5 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_5_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3CamcarZscore6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3_global_6_monthly_zscore:chirpsv3_global_6_monthly_zscore',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.0 6 Monthly Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3_global_6_monthly_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHIRPS Parts Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3partsanomCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3anompart_global_1_monthly_data:chirpsv3anompart_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chirps_anom_parts',
                  legend: {
                    style: 'chirps_anom_parts',
                    customImageURL: null,
                    title: 'CHIRPS Parts Anom v3.0 Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3anompart_global_1_monthly_data',
                    chartYAxisLabel: 'CHIRPS Parts Anom',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHIRPS Parts Anom Weights',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3partsanomwtCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3anomwt_global_1_monthly_data:chirpsv3anomwt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chirps_anom_wt',
                  legend: {
                    style: 'chirps_anom_wt',
                    customImageURL: null,
                    title: 'CHIRPS Parts Anom Weights v3.0 Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3anomwt_global_1_monthly_data',
                    chartYAxisLabel: 'CHIRPS Parts Anom Weights',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Density',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3stndensityCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stndensity_global_1_monthly_data:chirpsv3stndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Density',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stndensity_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRPS3-GEFS
         */
        {
          type: 'folder',
          title: 'CHIRPS3-GEFS',
          description:
            "CHIRPS3-GEFS is a product that combines the NCEP's Global Ensemble Forecast System (GEFS)16 day precipitation forecasts with the CHIRPS VERSION 3.0 climatology to produce a CHIRPS compatible (latitude 60N - 60S, ~0.05 degree resolution) dekadal forecasts. Precipitation forecasts are produced daily and accumulated for the 5 day forecast period beginning on the date in the title bar. Version 12 (v12) incorporates thenew GEFS forecast model v12, as of Oct. 2020, and uses the 0.5 deg (p5) resolutionrun for all days.",
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaData05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_data:chirps3_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 05 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_05day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaData10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_data:chirps3_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 10 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_10day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaData15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_data:chirps3_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 15 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_15day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data Categories',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaDataCat05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_data:chirps3_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 05 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_05day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaDataCat10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_data:chirps3_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 10 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_10day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaDataCat15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_data:chirps3_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 15 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_15day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaAnomaly05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_anom:chirps3_gefs_global_05day_anom',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 05 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_05day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaAnomaly10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_anom:chirps3_gefs_global_10day_anom',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 10 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_10day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsAfricaAnomaly15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_anom:chirps3_gefs_global_15day_anom',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 15 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_15day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS3-GEFS',
          description:
            "CHIRPS3-GEFS is a product that combines the NCEP's Global Ensemble Forecast System (GEFS)16 day precipitation forecasts with the CHIRPS VERSION 3.0 climatology to produce a CHIRPS compatible (latitude 60N - 60S, ~0.05 degree resolution) dekadal forecasts. Precipitation forecasts are produced daily and accumulated for the 5 day forecast period beginning on the date in the title bar. Version 12 (v12) incorporates thenew GEFS forecast model v12, as of Oct. 2020, and uses the 0.5 deg (p5) resolutionrun for all days.",
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalData05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_data:chirps3_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 05 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_05day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalData10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_data:chirps3_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 10 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_10day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalData15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_data:chirps3_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 15 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_15day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data Categories',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalDataCat05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_data:chirps3_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 05 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_05day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalDataCat10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_data:chirps3_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 10 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_10day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalDataCat15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_data:chirps3_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 15 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_15day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalAnomaly05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_anom:chirps3_gefs_global_05day_anom',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 05 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_05day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalAnomaly10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_anom:chirps3_gefs_global_10day_anom',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 10 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_10day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsGlobalAnomaly15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_anom:chirps3_gefs_global_15day_anom',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 15 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_15day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS3-GEFS',
          description:
            "CHIRPS3-GEFS is a product that combines the NCEP's Global Ensemble Forecast System (GEFS)16 day precipitation forecasts with the CHIRPS VERSION 3.0 climatology to produce a CHIRPS compatible (latitude 60N - 60S, ~0.05 degree resolution) dekadal forecasts. Precipitation forecasts are produced daily and accumulated for the 5 day forecast period beginning on the date in the title bar. Version 12 (v12) incorporates thenew GEFS forecast model v12, as of Oct. 2020, and uses the 0.5 deg (p5) resolutionrun for all days.",
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarData05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_data:chirps3_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 05 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_05day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarData10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_data:chirps3_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 10 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_10day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarData15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_data:chirps3_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS3-GEFS 15 day Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_15day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data Categories',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarDataCat05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_data:chirps3_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 05 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_05day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarDataCat10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_data:chirps3_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 10 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_10day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarDataCat15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_data:chirps3_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_categories',
                  legend: {
                    style: 'precip_dekad_data_categories',
                    customImageURL: null,
                    title: 'CHIRPS3-GEFS 15 day Data Categories (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps3_gefs_global_15day_data',
                    chartYAxisLabel: 'Rainfall Forecast (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarAnomaly05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_05day_anom:chirps3_gefs_global_05day_anom',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 05 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_05day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarAnomaly10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_10day_anom:chirps3_gefs_global_10day_anom',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 10 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_10day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirps3gefsCamcarAnomaly15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirps3_gefs_global_15day_anom:chirps3_gefs_global_15day_anom',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS3-GEFS 15 day Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps3_gefs_global_15day_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRPS v3 prelim
         */
        {
          type: 'folder',
          title: 'CHIRPS v3.0 Prelim',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (60&deg; S - 60&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. The Preliminary version is produced 2 days after every pentad of the month and containsfewer station values than the final version produced month.  <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_data:chirpsv3-prelim-early_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_data:chirpsv3-prelim-early_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_data:chirpsv3-prelim-early_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_anom:chirpsv3-prelim-early_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_anom:chirpsv3-prelim-early_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_anom:chirpsv3-prelim-early_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_zscore:chirpsv3-prelim-early_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_zscore:chirpsv3-prelim-early_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_zscore:chirpsv3-prelim-early_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 Prelim',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (60&deg; S - 60&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. The Preliminary version is produced 2 days after every pentad of the month and containsfewer station values than the final version produced month.  <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_data:chirpsv3-prelim-early_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_data:chirpsv3-prelim-early_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_data:chirpsv3-prelim-early_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_anom:chirpsv3-prelim-early_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_anom:chirpsv3-prelim-early_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_anom:chirpsv3-prelim-early_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_zscore:chirpsv3-prelim-early_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_zscore:chirpsv3-prelim-early_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_zscore:chirpsv3-prelim-early_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 Prelim',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (60&deg; S - 60&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. The Preliminary version is produced 2 days after every pentad of the month and containsfewer station values than the final version produced month.  <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_data:chirpsv3-prelim-early_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_data:chirpsv3-prelim-early_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_data:chirpsv3-prelim-early_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_anom:chirpsv3-prelim-early_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_anom:chirpsv3-prelim-early_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_anom:chirpsv3-prelim-early_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_pentad_zscore:chirpsv3-prelim-early_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Pentadal Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_dekad_zscore:chirpsv3-prelim-early_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsv3prelimearlyCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3-prelim-early_global_1_monthly_zscore:chirpsv3-prelim-early_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Z-Score (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpsv3-prelim-early_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRP v3.0
         */
        {
          type: 'folder',
          title: 'CHIRP v3.0',
          description:
            'Climate Hazard Center InfraRed Precipitation  (CHIRP) is a global (60&deg; S - 60&deg; N,180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRP is produced 2 days after every pentad of the month and is not blended with any station values, it is based solely on satellite measurements. <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_data:chirpv3p0_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_data:chirpv3p0_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_data:chirpv3p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_data:chirpv3p0_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_data:chirpv3p0_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaData4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_data:chirpv3p0_global_4_monthly_data',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 4 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaData5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_data:chirpv3p0_global_5_monthly_data',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 5 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaData6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_data:chirpv3p0_global_6_monthly_data',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 6 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_anom:chirpv3p0_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP v3.0 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_anom:chirpv3p0_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP v3.0 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_anom:chirpv3p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_anom:chirpv3p0_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_anom:chirpv3p0_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomaly4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_anom:chirpv3p0_global_4_monthly_anom',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 4 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomaly5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_anom:chirpv3p0_global_5_monthly_anom',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 5 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaAnomaly6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_anom:chirpv3p0_global_6_monthly_anom',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 6 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_zscore:chirpv3p0_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_zscore:chirpv3p0_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_zscore:chirpv3p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_zscore:chirpv3p0_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_zscore:chirpv3p0_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscore4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_zscore:chirpv3p0_global_4_monthly_zscore',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 4 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscore5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_zscore:chirpv3p0_global_5_monthly_zscore',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 5 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0AfricaZscore6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_zscore:chirpv3p0_global_6_monthly_zscore',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 6 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Climatology',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0climAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0clim_global_pentad_data:chirpv3p0clim_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Pentadal Climatology (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0clim_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0climAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0clim_global_1_monthly_data:chirpv3p0clim_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 Monthly Climatology (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0clim_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Fill Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_pentad_data:chirpv3p0fillmap_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'mask_raster',
                  legend: {
                    style: 'mask_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Pentadal Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_1_monthly_data:chirpv3p0fillmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'fillmap_monthly_raster',
                  legend: {
                    style: 'fillmap_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Monthly Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapAfricaDataAnnual',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_year_data:chirpv3p0fillmap_global_year_data',
                  title: 'Annual',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'fillmap_yearly_raster',
                  legend: {
                    style: 'fillmap_yearly_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Annual Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_year_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'year',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRP v3.0',
          description:
            'Climate Hazard Center InfraRed Precipitation  (CHIRP) is a global (60&deg; S - 60&deg; N,180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRP is produced 2 days after every pentad of the month and is not blended with any station values, it is based solely on satellite measurements. <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_data:chirpv3p0_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_data:chirpv3p0_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_data:chirpv3p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_data:chirpv3p0_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_data:chirpv3p0_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalData4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_data:chirpv3p0_global_4_monthly_data',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 4 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalData5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_data:chirpv3p0_global_5_monthly_data',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 5 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalData6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_data:chirpv3p0_global_6_monthly_data',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 6 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_anom:chirpv3p0_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP v3.0 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_anom:chirpv3p0_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP v3.0 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_anom:chirpv3p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_anom:chirpv3p0_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_anom:chirpv3p0_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomaly4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_anom:chirpv3p0_global_4_monthly_anom',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 4 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomaly5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_anom:chirpv3p0_global_5_monthly_anom',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 5 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalAnomaly6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_anom:chirpv3p0_global_6_monthly_anom',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 6 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_zscore:chirpv3p0_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_zscore:chirpv3p0_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_zscore:chirpv3p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_zscore:chirpv3p0_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_zscore:chirpv3p0_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscore4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_zscore:chirpv3p0_global_4_monthly_zscore',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 4 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscore5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_zscore:chirpv3p0_global_5_monthly_zscore',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 5 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0GlobalZscore6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_zscore:chirpv3p0_global_6_monthly_zscore',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 6 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Climatology',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0climGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0clim_global_pentad_data:chirpv3p0clim_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Pentadal Climatology (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0clim_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0climGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0clim_global_1_monthly_data:chirpv3p0clim_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 Monthly Climatology (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0clim_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Fill Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_pentad_data:chirpv3p0fillmap_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'mask_raster',
                  legend: {
                    style: 'mask_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Pentadal Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_1_monthly_data:chirpv3p0fillmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'fillmap_monthly_raster',
                  legend: {
                    style: 'fillmap_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Monthly Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapGlobalDataAnnual',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_year_data:chirpv3p0fillmap_global_year_data',
                  title: 'Annual',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'fillmap_yearly_raster',
                  legend: {
                    style: 'fillmap_yearly_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Annual Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_year_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'year',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRP v3.0',
          description:
            'Climate Hazard Center InfraRed Precipitation  (CHIRP) is a global (60&deg; S - 60&deg; N,180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRP is produced 2 days after every pentad of the month and is not blended with any station values, it is based solely on satellite measurements. <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_data:chirpv3p0_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_data:chirpv3p0_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_data:chirpv3p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_data:chirpv3p0_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_data:chirpv3p0_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarData4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_data:chirpv3p0_global_4_monthly_data',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 4 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarData5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_data:chirpv3p0_global_5_monthly_data',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 5 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarData6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_data:chirpv3p0_global_6_monthly_data',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_multi_monthly_data_raster',
                  legend: {
                    style: 'precip_multi_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 6 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_anom:chirpv3p0_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP v3.0 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_anom:chirpv3p0_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP v3.0 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_anom:chirpv3p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_anom:chirpv3p0_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_anom:chirpv3p0_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirpv3p0_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomaly4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_anom:chirpv3p0_global_4_monthly_anom',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 4 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomaly5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_anom:chirpv3p0_global_5_monthly_anom',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 5 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarAnomaly6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_anom:chirpv3p0_global_6_monthly_anom',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP v3.0 6 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_pentad_zscore:chirpv3p0_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_dekad_zscore:chirpv3p0_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_1_monthly_zscore:chirpv3p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_2_monthly_zscore:chirpv3p0_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_3_monthly_zscore:chirpv3p0_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirpv3p0_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscore4Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_4_monthly_zscore:chirpv3p0_global_4_monthly_zscore',
                  title: '4-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 4 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_4_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '4month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscore5Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_5_monthly_zscore:chirpv3p0_global_5_monthly_zscore',
                  title: '5-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 5 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_5_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '5month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0CamcarZscore6Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0_global_6_monthly_zscore:chirpv3p0_global_6_monthly_zscore',
                  title: '6-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP v3.0 6 Month Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0_global_6_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '6month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Climatology',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0climCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0clim_global_pentad_data:chirpv3p0clim_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP v3.0 Pentadal Climatology (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0clim_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0climCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0clim_global_1_monthly_data:chirpv3p0clim_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP v3.0 Monthly Climatology (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0clim_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Fill Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_pentad_data:chirpv3p0fillmap_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'mask_raster',
                  legend: {
                    style: 'mask_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Pentadal Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_1_monthly_data:chirpv3p0fillmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'fillmap_monthly_raster',
                  legend: {
                    style: 'fillmap_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Monthly Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpv3p0fillmapCamcarDataAnnual',
                  isWMST: true,
                  wmstName: 'EWX_chirpv3p0fillmap_global_year_data:chirpv3p0fillmap_global_year_data',
                  title: 'Annual',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'fillmap_yearly_raster',
                  legend: {
                    style: 'fillmap_yearly_raster',
                    customImageURL: null,
                    title: 'CHIRP v3.0 Annual Fill Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpv3p0fillmap_global_year_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'year',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRPS v2 Final
         */
        {
          type: 'folder',
          title: 'CHIRPS v2.0 Final',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRPS data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Center (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation andScience(EROS) Center. See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page</a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_data:chirps_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_data:chirps_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_data:chirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_data:chirps_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_data:chirps_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_anom:chirps_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_anom:chirps_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_anom:chirps_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_anom:chirps_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_anom:chirps_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_zscore:chirps_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_zscore:chirps_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_zscore:chirps_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_zscore:chirps_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsAfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_zscore:chirps_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 Final',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRPS data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Center (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation andScience(EROS) Center. See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page</a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_data:chirps_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_data:chirps_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_data:chirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_data:chirps_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_data:chirps_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_anom:chirps_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_anom:chirps_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_anom:chirps_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_anom:chirps_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_anom:chirps_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_zscore:chirps_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_zscore:chirps_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_zscore:chirps_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_zscore:chirps_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsGlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_zscore:chirps_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 Final',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRPS data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Center (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation andScience(EROS) Center. See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page</a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_data:chirps_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_data:chirps_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_data:chirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_data:chirps_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_data:chirps_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_anom:chirps_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_anom:chirps_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_anom:chirps_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legendsprecip_monthly_anom_raster.png/',
                    title: 'CHIRPS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_anom:chirps_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_anom:chirps_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_pentad_zscore:chirps_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_dekad_zscore:chirps_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_1_monthly_zscore:chirps_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_2_monthly_zscore:chirps_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsCamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps_global_3_monthly_zscore:chirps_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRPS v2 prelim
         */
        {
          type: 'folder',
          title: 'CHIRPS v2.0 Prelim',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. The Preliminary version is produced 2 days after every pentad of the month and containsfewer station values than the final version produced month.  <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_data:chirps-prelim_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Pentadal Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_data:chirps-prelim_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_data:chirps-prelim_global_1-month_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_1-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_data:chirps-prelim_global_2-month_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_2-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_data:chirps-prelim_global_3-month_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_3-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_anom:chirps-prelim_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Pentadal Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_anomaly:chirps-prelim_global_dekad_anomaly',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_dekad_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_anomaly:chirps-prelim_global_1-month_anomaly',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_1-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_anomaly:chirps-prelim_global_2-month_anomaly',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_2-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_anomaly:chirps-prelim_global_3-month_anomaly',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_3-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_zscore:chirps-prelim_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Pentadal Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_zscore:chirps-prelim_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_zscore:chirps-prelim_global_1-month_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_1-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_zscore:chirps-prelim_global_2-month_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_2-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimAfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_zscore:chirps-prelim_global_3-month_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_3-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 Prelim',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. The Preliminary version is produced 2 days after every pentad of the month and containsfewer station values than the final version produced month.  <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_data:chirps-prelim_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Pentadal Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_data:chirps-prelim_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_data:chirps-prelim_global_1-month_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_1-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_data:chirps-prelim_global_2-month_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_2-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_data:chirps-prelim_global_3-month_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_3-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_anom:chirps-prelim_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Pentadal Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_anomaly:chirps-prelim_global_dekad_anomaly',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_dekad_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_anomaly:chirps-prelim_global_1-month_anomaly',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_1-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_anomaly:chirps-prelim_global_2-month_anomaly',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_2-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_anomaly:chirps-prelim_global_3-month_anomaly',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_3-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_zscore:chirps-prelim_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Pentadal Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_zscore:chirps-prelim_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_zscore:chirps-prelim_global_1-month_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_1-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_zscore:chirps-prelim_global_2-month_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_2-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimGlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_zscore:chirps-prelim_global_3-month_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_3-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 Prelim',
          description:
            'Climate Hazard Center InfraRed Precipitation with Stations (CHIRPS) is a global (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. The Preliminary version is produced 2 days after every pentad of the month and containsfewer station values than the final version produced month.  <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_data:chirps-prelim_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Pentadal Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_data:chirps-prelim_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_data:chirps-prelim_global_1-month_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_1-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_data:chirps-prelim_global_2-month_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_2-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_data:chirps-prelim_global_3-month_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-prelim_global_3-month_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_anom:chirps-prelim_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS Pentadal Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_anomaly:chirps-prelim_global_dekad_anomaly',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_dekad_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_anomaly:chirps-prelim_global_1-month_anomaly',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_1-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_anomaly:chirps-prelim_global_2-month_anomaly',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_2-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_anomaly:chirps-prelim_global_3-month_anomaly',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-prelim_global_3-month_anomaly',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_pentad_zscore:chirps-prelim_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS Pentadal Zscore ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_dekad_zscore:chirps-prelim_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_1-month_zscore:chirps-prelim_global_1-month_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_1-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_2-month_zscore:chirps-prelim_global_2-month_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_2-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpsprelimCamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-prelim_global_3-month_zscore:chirps-prelim_global_3-month_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS-PRELIM 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-prelim_global_3-month_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRP v2.0
         */
        {
          type: 'folder',
          title: 'CHIRP v2.0',
          description:
            'Climate Hazard Center InfraRed Precipitation  (CHIRP) is a global (50&deg; S - 50&deg; N,180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRP is produced 2 days after every pentad of the month and is not blended with any station values, it is based solely on satellite measurements. <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_data:chirp_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_data:chirp_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRPS Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_data:chirp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_data:chirp_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_data:chirp_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpAfricaAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_anom:chirp_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_anom:chirp_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_anom:chirp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_anom:chirp_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_anom:chirp_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_zscore:chirp_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_zscore:chirp_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_zscore:chirp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_zscore:chirp_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpAfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_zscore:chirp_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRP v2.0',
          description:
            'Climate Hazard Center InfraRed Precipitation  (CHIRP) is a global (50&deg; S - 50&deg; N,180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRP is produced 2 days after every pentad of the month and is not blended with any station values, it is based solely on satellite measurements. <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_data:chirp_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_data:chirp_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_data:chirp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_data:chirp_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_data:chirp_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpGlobalAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_anom:chirp_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_anom:chirp_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_anom:chirp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_anom:chirp_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_anom:chirp_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
              {
                  type: 'layer',
                  id: 'chirpaGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_zscore:chirp_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_zscore:chirp_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_zscore:chirp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_zscore:chirp_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpGlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_zscore:chirp_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRP v2.0',
          description:
            'Climate Hazard Center InfraRed Precipitation  (CHIRP) is a global (50&deg; S - 50&deg; N,180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation time series. CHIRP is produced 2 days after every pentad of the month and is not blended with any station values, it is based solely on satellite measurements. <br>See <a  target=\"_blank\"href="http://chc.ucsb.edu/data/chirps"> CHIRPS web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_data:chirp_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_data:chirp_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHIRP Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_data:chirp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_data:chirp_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_data:chirp_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRP 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpCamcarAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_anom:chirp_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_anom:chirp_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'CHIRP Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_anom:chirp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_anom:chirp_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_anom:chirp_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRP 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirp_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1981-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_pentad_zscore:chirp_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirp_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_dekad_zscore:chirp_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_1_monthly_zscore:chirp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_2_monthly_zscore:chirp_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirpCamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirp_global_3_monthly_zscore:chirp_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRP 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirp_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTSmax
         */
        {
          type: 'folder',
          title: 'CHIRTSmax',
          description:
            'Climate Hazard Center InfraRed Temperature with Stations maximum (CHIRTSmax) is a beta version of global (60&deg; S - 70&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1983 to near-present gridded maximum temperature time series. CHIRTSmax data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Center (CHC) and the U.S. Geological Survey (USGS) EarthResources Observation and Science (EROS) Center.  <br>See <a target=\"_blank\" href="http://chc.ucsb.edu"> CHC web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_data:chirtsmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_anom:chirtsmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtsmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_zscore:chirtsmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtsmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTSmax',
          description:
            'Climate Hazard Center InfraRed Temperature with Stations maximum (CHIRTSmax) is a beta version of global (60&deg; S - 70&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1983 to near-present gridded maximum temperature time series. CHIRTSmax data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Center (CHC) and the U.S. Geological Survey (USGS) EarthResources Observation and Science (EROS) Center.  <br>See <a target=\"_blank\" href="http://chc.ucsb.edu"> CHC web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_data:chirtsmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_anom:chirtsmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtsmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_zscore:chirtsmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtsmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTSmax',
          description:
            'Climate Hazard Center InfraRed Temperature with Stations maximum (CHIRTSmax) is a beta version of global (60&deg; S - 70&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1983 to near-present gridded maximum temperature time series. CHIRTSmax data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Center (CHC) and the U.S. Geological Survey (USGS) EarthResources Observation and Science (EROS) Center.  <br>See <a target=\"_blank\" href="http://chc.ucsb.edu"> CHC web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_data:chirtsmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_anom:chirtsmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtsmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsmaxCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsmax_global_1_monthly_zscore:chirtsmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtsmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTmax
         */
        {
          type: 'folder',
          title: 'CHIRTmax',
          description:
            'Climate Hazard group InfraRed Temperature with Stations maximum (CHIRTmax) is a beta version of global (60&deg; S - 70&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1983 to near-present gridded maximum temperature time series. CHIRTmax data are produced by scientists at the Universityof California, Santa Barbara (UCSB) Climate Hazard Group (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.  <br>See <a target=\"_blank\" href="http://chc.ucsb.edu"> CHC web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_data:chirtmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_anom:chirtmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_zscore:chirtmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTmax',
          description:
            'Climate Hazard group InfraRed Temperature with Stations maximum (CHIRTmax) is a beta version of global (60&deg; S - 70&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1983 to near-present gridded maximum temperature time series. CHIRTmax data are produced by scientists at the Universityof California, Santa Barbara (UCSB) Climate Hazard Group (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.  <br>See <a target=\"_blank\" href="http://chc.ucsb.edu"> CHC web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_data:chirtmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_anom:chirtmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_zscore:chirtmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTmax',
          description:
            'Climate Hazard group InfraRed Temperature with Stations maximum (CHIRTmax) is a beta version of global (60&deg; S - 70&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1983 to near-present gridded maximum temperature time series. CHIRTmax data are produced by scientists at the Universityof California, Santa Barbara (UCSB) Climate Hazard Group (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.  <br>See <a target=\"_blank\" href="http://chc.ucsb.edu"> CHC web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_data:chirtmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_anom:chirtmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtmaxCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtmax_global_1_monthly_zscore:chirtmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTSvpd
         */
        {
          type: 'folder',
          title: 'CHIRTSvpd',
          description:
            'Vapor Pressure Deficit',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_data:chirtsvpd_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_data:chirtsvpd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_anom:chirtsvpd_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_anom:chirtsvpd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtsvpd_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_zscore:chirtsvpd_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_zscore:chirtsvpd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtsvpd_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTSvpd',
          description:
            'Vapor Pressure Deficit',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_data:chirtsvpd_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_data:chirtsvpd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_anom:chirtsvpd_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_anom:chirtsvpd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtsvpd_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_zscore:chirtsvpd_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_zscore:chirtsvpd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtsvpd_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTSvpd',
          description:
            'Vapor Pressure Deficit',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_data:chirtsvpd_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_data:chirtsvpd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_anom:chirtsvpd_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_anom:chirtsvpd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtsvpd_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsvpdCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_pentad_zscore:chirtsvpd_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsvpdCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtsvpd_global_1_monthly_zscore:chirtsvpd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSvpd Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtsvpd_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTShi
         */
        {
          type: 'folder',
          title: 'CHIRTShi',
          description:
            'Heat Index',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_data:chirtshi_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtshi_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_data:chirtshi_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtshi_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_anom:chirtshi_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtshi_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_anom:chirtshi_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtshi_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_zscore:chirtshi_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtshi_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_zscore:chirtshi_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtshi_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTShi',
          description:
            'Heat Index',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_data:chirtshi_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtshi_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_data:chirtshi_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtshi_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_anom:chirtshi_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtshi_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_anom:chirtshi_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtshi_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_zscore:chirtshi_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtshi_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_zscore:chirtshi_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtshi_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTShi',
          description:
            'Heat Index',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_data:chirtshi_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtshi_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_data:chirtshi_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtsvpd_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_anom:chirtshi_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTShi Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtshi_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_anom:chirtshi_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtshi_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtshiCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_pentad_zscore:chirtshi_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSvpd Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'Zscore',
                    rasterDataset: 'chirtshi_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtshiCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtshi_global_1_monthly_zscore:chirtshi_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTShi Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtshi_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTSwbgt
         */
        {
          type: 'folder',
          title: 'CHIRTSwbgt',
          description:
            'Wet Bulb Globe Temperature',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_data:chirtswbgt_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_data:chirtswbgt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_anom:chirtswbgt_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_anom:chirtswbgt_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtswbgt_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_zscore:chirtswbgt_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_zscore:chirtswbgt_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtswbgt_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTSwbgt',
          description:
            'Wet Bulb Globe Temperature',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_data:chirtswbgt_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_data:chirtswbgt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_anom:chirtswbgt_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_anom:chirtswbgt_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtswbgt_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_zscore:chirtswbgt_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_zscore:chirtswbgt_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtswbgt_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTSwbgt',
          description:
            'Wet Bulb Globe Temperature',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_data:chirtswbgt_global_pentad_data',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_data:chirtswbgt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Data',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_anom:chirtswbgt_global_pentad_anom',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_anom:chirtswbgt_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Anomaly',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirtswbgt_global_1_monthly_anom',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1983-2016 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtswbgtCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_pentad_zscore:chirtswbgt_global_pentad_zscore',
                  title: 'Pentad',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Pentadal Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirtswbgt_global_pentad_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtswbgtCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirtswbgt_global_1_monthly_zscore:chirtswbgt_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTSwbgt Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirtswbgt_global_1_monthly_zscore',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS
         */
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="https://wiki.chc.ucsb.edu/CHIRPS_Reality_Checks"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_data:rchecks-v2p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_anom:rchecks-v2p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_zscore:rchecks-v2p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksstdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0std_global_1_monthly_data:rchecks-v2p0std_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0std_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std Counts',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckscountsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0counts_global_1_monthly_data:rchecks-v2p0counts_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'soil_moist_perc_vol_water_cont',
                  legend: {
                    style: 'soil_moist_perc_vol_water_cont',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0counts_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Ratio Std over Chirps Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksratioAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0ratiostd_global_1_monthly_data:rchecks-v2p0ratiostd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ratiomap_raster',
                  legend: {
                    style: 'ratiomap_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0ratiostd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'SelChirps',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksselchirpsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0selchirps_global_1_monthly_data:rchecks-v2p0selchirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0selchirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="https://wiki.chc.ucsb.edu/CHIRPS_Reality_Checks"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_data:rchecks-v2p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_anom:rchecks-v2p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_zscore:rchecks-v2p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksstdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0std_global_1_monthly_data:rchecks-v2p0std_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0std_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std Counts',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckscountsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0counts_global_1_monthly_data:rchecks-v2p0counts_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'soil_moist_perc_vol_water_cont',
                  legend: {
                    style: 'soil_moist_perc_vol_water_cont',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0counts_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Ratio Std over Chirps Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksratioGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0ratiostd_global_1_monthly_data:rchecks-v2p0ratiostd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ratiomap_raster',
                  legend: {
                    style: 'ratiomap_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0ratiostd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'SelChirps',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksselchirpsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0selchirps_global_1_monthly_data:rchecks-v2p0selchirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0selchirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="https://wiki.chc.ucsb.edu/CHIRPS_Reality_Checks"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_data:rchecks-v2p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_anom:rchecks-v2p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0_global_1_monthly_zscore:rchecks-v2p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksstdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0std_global_1_monthly_data:rchecks-v2p0std_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0std_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std Counts',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckscountsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0counts_global_1_monthly_data:rchecks-v2p0counts_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'soil_moist_perc_vol_water_cont',
                  legend: {
                    style: 'soil_moist_perc_vol_water_cont',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0counts_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Ratio Std over Chirps Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksratioCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0ratiostd_global_1_monthly_data:rchecks-v2p0ratiostd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ratiomap_raster',
                  legend: {
                    style: 'ratiomap_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0ratiostd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'SelChirps',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksselchirpsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0selchirps_global_1_monthly_data:rchecks-v2p0selchirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0selchirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS-HD
         */
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS HD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_data:rchecks-v2p0-hd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data First Run',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_data:rchecks-v2p0-hd-firstrun_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_anom:rchecks-v2p0-hd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly First Run',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_anom:rchecks-v2p0-hd-firstrun_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_zscore:rchecks-v2p0-hd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score First Run',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_zscore:rchecks-v2p0-hd-firstrun_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS HD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_data:rchecks-v2p0-hd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data First Run',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_data:rchecks-v2p0-hd-firstrun_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_anom:rchecks-v2p0-hd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly First Run',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_anom:rchecks-v2p0-hd-firstrun_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_zscore:rchecks-v2p0-hd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score First Run',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_zscore:rchecks-v2p0-hd-firstrun_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS HD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_data:rchecks-v2p0-hd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data First Run',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_data:rchecks-v2p0-hd-firstrun_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_anom:rchecks-v2p0-hd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly First Run',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_anom:rchecks-v2p0-hd-firstrun_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd_global_1_monthly_zscore:rchecks-v2p0-hd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0-hd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score First Run',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rcheckshdfirstrunCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-hd-firstrun_global_1_monthly_zscore:rchecks-v2p0-hd-firstrun_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS HD First Run Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rchecks-v2p0-hd-firstrun_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS-UHD
         */
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS UHD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksuhdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-uhd_global_1_monthly_data:rchecks-v2p0-uhd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS UHD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-uhd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksuhdAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-uhd_global_1_monthly_anom:rchecks-v2p0-uhd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS UHD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-uhd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS UHD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksuhdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-uhd_global_1_monthly_data:rchecks-v2p0-uhd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS UHD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-uhd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksuhdGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-uhd_global_1_monthly_anom:rchecks-v2p0-uhd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS UHD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-uhd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS UHD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksuhdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-uhd_global_1_monthly_data:rchecks-v2p0-uhd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS UHD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v2p0-uhd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksuhdCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v2p0-uhd_global_1_monthly_anom:rchecks-v2p0-uhd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS UHD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v2p0-uhd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS-Anchors
         */
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS Anchors',
          description:
            'CHIRPS Rchecks with only the Anchor stations included. This is the first step in blendingthe stations in.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksanchorsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-anchors_global_1_monthly_data:rchecks-anchors_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS  Anchors Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-anchors_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksanchorsAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-anchors_global_1_monthly_anom:rchecks-anchors_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Anchors Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-anchors_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS Anchors',
          description:
            'CHIRPS Rchecks with only the Anchor stations included. This is the first step in blendingthe stations in.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksanchorsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-anchors_global_1_monthly_data:rchecks-anchors_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Anchors Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-anchors_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksanchorsGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-anchors_global_1_monthly_anom:rchecks-anchors_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Anchors Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-anchors_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS Anchors',
          description:
            'CHIRPS Rchecks with only the Anchor stations included. This is the first step in blendingthe stations in.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksanchorsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-anchors_global_1_monthly_data:rchecks-anchors_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Anchors Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-anchors_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksanchorsCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-anchors_global_1_monthly_anom:rchecks-anchors_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Anchors Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-anchors_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS 2nd Blend
         */
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS 2nd Blend',
          description:
            'CHIRPS Rchecks with the second set of stations blended in. This is the final step in blending the stations in.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecks2ndblendAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-2ndround_global_1_monthly_data:rchecks-2ndround_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS 2nd Blend Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-2ndround_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecks2ndblendAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-2ndround_global_1_monthly_anom:rchecks-2ndround_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS 2nd Blend Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-2ndround_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS 2nd Blend',
          description:
            'CHIRPS Rchecks with the second set of stations blended in. This is the final step in blending the stations in.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecks2ndblendGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-2ndround_global_1_monthly_data:rchecks-2ndround_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS 2nd Blend Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-2ndround_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecks2ndblendGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-2ndround_global_1_monthly_anom:rchecks-2ndround_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS 2nd Blend Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-2ndround_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v2.0 RCHECKS 2nd Blend',
          description:
            'CHIRPS Rchecks with the second set of stations blended in. This is the final step in blending the stations in.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecks2ndblendCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-2ndround_global_1_monthly_data:rchecks-2ndround_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS 2nd Blend Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-2ndround_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecks2ndblendCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-2ndround_global_1_monthly_anom:rchecks-2ndround_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS 2nd Blend Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-2ndround_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS v3.0
         */
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="https://wiki.chc.ucsb.edu/CHIRPS_Reality_Checks"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_data:rchecks-v3p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_anom:rchecks-v3p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_zscore:rchecks-v3p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3stnstackmapAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Leg Corr',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3legcorrAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0legcorr_global_1_monthly_data:rchecks-v3p0legcorr_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0legcorr_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std Counts',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3countsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0counts_global_1_monthly_data:rchecks-v3p0counts_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'soil_moist_perc_vol_water_cont',
                  legend: {
                    style: 'soil_moist_perc_vol_water_cont',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0counts_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Ratio Legcorr Std over Chirps Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3ratioAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0ratiolegcorr_global_1_monthly_data:rchecks-v3p0ratiolegcorr_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ratiomap_raster',
                  legend: {
                    style: 'ratiomap_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0ratiolegcorr_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'SelChirps',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3selchirpsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0selchirps_global_1_monthly_data:rchecks-v3p0selchirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0selchirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="https://wiki.chc.ucsb.edu/CHIRPS_Reality_Checks"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_data:rchecks-v3p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_anom:rchecks-v3p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_zscore:rchecks-v3p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3stnstackmapGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Leg Corr',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3legcorrGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0legcorr_global_1_monthly_data:rchecks-v3p0legcorr_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0legcorr_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std Counts',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3countsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0counts_global_1_monthly_data:rchecks-v3p0counts_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'soil_moist_perc_vol_water_cont',
                  legend: {
                    style: 'soil_moist_perc_vol_water_cont',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0counts_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Ratio Legcorr Std over Chirps Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3ratioGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0ratiolegcorr_global_1_monthly_data:rchecks-v3p0ratiolegcorr_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ratiomap_raster',
                  legend: {
                    style: 'ratiomap_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0ratiolegcorr_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'SelChirps',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3selchirpsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0selchirps_global_1_monthly_data:rchecks-v3p0selchirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0selchirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="https://wiki.chc.ucsb.edu/CHIRPS_Reality_Checks"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_data:rchecks-v3p0_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_anom:rchecks-v3p0_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0_global_1_monthly_zscore:rchecks-v3p0_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3stnstackmapCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Leg Corr',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3legcorrCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0legcorr_global_1_monthly_data:rchecks-v3p0legcorr_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0legcorr_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Std Counts',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3countsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0counts_global_1_monthly_data:rchecks-v3p0counts_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'soil_moist_perc_vol_water_cont',
                  legend: {
                    style: 'soil_moist_perc_vol_water_cont',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0counts_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Ratio Legcorr Std over Chirps Std',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3ratioCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0ratiolegcorr_global_1_monthly_data:rchecks-v3p0ratiolegcorr_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ratiomap_raster',
                  legend: {
                    style: 'ratiomap_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0ratiolegcorr_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'SelChirps',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3selchirpsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0selchirps_global_1_monthly_data:rchecks-v3p0selchirps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRPS RCHECKS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0selchirps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS-HD v3.0
         */
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS HD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_data:rchecks-v3p0-hd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS HD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_anom:rchecks-v3p0-hd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS HD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_zscore:rchecks-v3p0-hd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3hdstnstackmapAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS HD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_data:rchecks-v3p0-hd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS HD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_anom:rchecks-v3p0-hd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS HD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_zscore:rchecks-v3p0-hd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3hdstnstackmapGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS HD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_data:rchecks-v3p0-hd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS HD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_anom:rchecks-v3p0-hd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS HD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3hdCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-hd_global_1_monthly_zscore:rchecks-v3p0-hd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-hd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3hdstnstackmapCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RCHECKS-UHD v3.0
         */
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS UHD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_data:rchecks-v3p0-uhd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS UHD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_anom:rchecks-v3p0-uhd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS UHD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_zscore:rchecks-v3p0-uhd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3uhdstnstackmapAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS UHD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_data:rchecks-v3p0-uhd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS UHD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_anom:rchecks-v3p0-uhd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS UHD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_zscore:rchecks-v3p0-uhd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3uhdstnstackmapGlobbalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.0 RCHECKS UHD',
          description:
            'CHIRPS RChecks is the CHIRPS dataset with precipitation station values embedded in the data as square blocks. This is used as a \"reality check\" to visually inspect station values and their effects on the final CHIRPS product before release every month. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/chirps/ewxchecks/index.html"> CHIRPS Reality Checks web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_data:rchecks-v3p0-uhd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS UHD Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_anom:rchecks-v3p0-uhd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS UHD Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rchecksv3uhdCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rchecks-v3p0-uhd_global_1_monthly_zscore:rchecks-v3p0-uhd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 6,
                    },
                  },
                  style: 'rchecks_zsc_raster',
                  legend: {
                    style: 'rchecks_zsc_raster',
                    customImageURL: null,
                    title: 'CHIRPS v3 RCHECKS Monthly Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rchecks-v3p0-uhd_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Station Stack Map',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3uhdstnstackmapCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirpsv3stackmap_global_1_monthly_data:chirpsv3stackmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'stn_stackmap',
                  legend: {
                    style: 'stn_stackmap',
                    customImageURL: null,
                    title: 'CHIRPS v3.0 Monthly Station Stack Map',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirpsv3stackmap_global_1_monthly_data',
                    chartYAxisLabel: '',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * RFE2
         */
        {
          type: 'folder',
          title: 'RFE2',
          description:
            'RFE2 is a merged satellite-gauge rainfall product produced by <a  target="_blank" href="https://www.cpc.ncep.noaa.gov/products/international/">NOAA&apos;s Climate Prediction Center</a>. EWX aquires African dekadal data at 0.1 x 0.1 degree spatial resolution via ftp. See the RFE2 readme file formore details.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rfe2AfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_dekad_data:rfe2_africa_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'RFE2 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_1_monthly_data:rfe2_africa_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'RFE2 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_2_monthly_data:rfe2_africa_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'RFE2 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_3_monthly_data:rfe2_africa_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'RFE2 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rfe2AfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_dekad_anom:rfe2_africa_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'RFE2 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_1_monthly_anom:rfe2_africa_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'RFE2 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_2_monthly_anom:rfe2_africa_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'RFE2 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_3_monthly_anom:rfe2_africa_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'RFE2 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rfe2AfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_dekad_zscore:rfe2_africa_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_1_monthly_zscore:rfe2_africa_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_2_monthly_zscore:rfe2_africa_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2AfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_3_monthly_zscore:rfe2_africa_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'RFE2',
          description:
            'RFE2 is a merged satellite-gauge rainfall product produced by <a  target="_blank" href="https://www.cpc.ncep.noaa.gov/products/international/">NOAA&apos;s Climate Prediction Center</a>. EWX aquires African dekadal data at 0.1 x 0.1 degree spatial resolution via ftp. See the RFE2 readme file formore details.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'rfe2GlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_dekad_data:rfe2_africa_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'RFE2 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_1_monthly_data:rfe2_africa_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'RFE2 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_2_monthly_data:rfe2_africa_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'RFE2 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_3_monthly_data:rfe2_africa_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'RFE2 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'rfe2_africa_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rfe2GlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_dekad_anom:rfe2_africa_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'RFE2 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_1_monthly_anom:rfe2_africa_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'RFE2 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_2_monthly_anom:rfe2_africa_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'RFE2 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_3_monthly_anom:rfe2_africa_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'RFE2 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'rfe2_africa_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'rfe2GlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_dekad_zscore:rfe2_africa_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_1_monthly_zscore:rfe2_africa_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_2_monthly_zscore:rfe2_africa_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'rfe2GlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_rfe2_africa_3_monthly_zscore:rfe2_africa_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'RFE2 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'rfe2_africa_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * LST006
         */
        {
          type: 'folder',
          title: 'LST006',
          description:
            'MODIS/Aqua Land Surface Temperature/Emissivity version 6 product (short name MYD11C1) provides land surface temperature (LST) and emissivity values in a 0.05&deg; grid over the entire globe. The MYD11C1 granule consists of 16 layers including the day and night LST layers and their quality indicator (QC) layers, six emissivity layers and their quality indicator (QC) layers, and five observation layers. <br>See <a target=\"_blank\" href="https://lpdaac.usgs.gov/dataset_discovery/modis/modis_products_table/myd11c1_v006/"> MYD11C1 web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006AfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_data:lst006_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_dekad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_data:lst006_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_data:lst006_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_2_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_data:lst006_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006AfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_anom:lst006_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_dekad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_anom:lst006_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_anom:lst006_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_2_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_anom:lst006_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006AfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_zscore:lst006_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_dekad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_zscore:lst006_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_zscore:lst006_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_2_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006AfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_zscore:lst006_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'LST006',
          description:
            'MODIS/Aqua Land Surface Temperature/Emissivity version 6 product (short name MYD11C1) provides land surface temperature (LST) and emissivity values in a 0.05&deg; grid over the entire globe. The MYD11C1 granule consists of 16 layers including the day and night LST layers and their quality indicator (QC) layers, six emissivity layers and their quality indicator (QC) layers, and five observation layers. <br>See <a target=\"_blank\" href="https://lpdaac.usgs.gov/dataset_discovery/modis/modis_products_table/myd11c1_v006/"> MYD11C1 web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006GlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_data:lst006_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_dekad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_data:lst006_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_data:lst006_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_2_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_data:lst006_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006GlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_anom:lst006_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_dekad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_anom:lst006_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_anom:lst006_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_2_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_anom:lst006_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006GlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_zscore:lst006_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_dekad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_zscore:lst006_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_zscore:lst006_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_2_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006GlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_zscore:lst006_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'LST006',
          description:
            'MODIS/Aqua Land Surface Temperature/Emissivity version 6 product (short name MYD11C1) provides land surface temperature (LST) and emissivity values in a 0.05&deg; grid over the entire globe. The MYD11C1 granule consists of 16 layers including the day and night LST layers and their quality indicator (QC) layers, six emissivity layers and their quality indicator (QC) layers, and five observation layers. <br>See <a target=\"_blank\" href="https://lpdaac.usgs.gov/dataset_discovery/modis/modis_products_table/myd11c1_v006/"> MYD11C1 web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006CamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_data:lst006_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_dekad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_data:lst006_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_data:lst006_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_2_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_data:lst006_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_data_raster',
                  legend: {
                    style: 'lst_data_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'lst006_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006CamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_anom:lst006_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_dekad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_anom:lst006_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_anom:lst006_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_2_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_anom:lst006_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_anom_raster',
                  legend: {
                    style: 'lst_anom_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'lst006_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'lst006CamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_dekad_zscore:lst006_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_dekad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_1_monthly_zscore:lst006_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_2_monthly_zscore:lst006_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_2_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'lst006CamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_lst006_global_3_monthly_zscore:lst006_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'LST006 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'lst006_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * IMERG late v07
         */
        {
          type: 'folder',
          title: 'IMERG late v07',
          description:
            'The Integrated Multi-satellitE Retrievals for GPM (IMERG) algorithm combines information from the GPM satellite constellation to estimate precipitation over the majority of the Earths surface.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7AfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_data:imerglatev7_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'IMERG late v07 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imerglatev7_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_data:imerglatev7_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'IMERG late v07 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imerglatev7_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7AfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_anom:imerglatev7_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'IMERG late v07 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imerglatev7_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_anom:imerglatev7_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'IMERG late v07 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imerglatev7_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7AfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_zscore:imerglatev7_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG late v07 Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imerglatev7_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_zscore:imerglatev7_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG late v07 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imerglatev7_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'IMERG late v07',
          description:
            'The Integrated Multi-satellitE Retrievals for GPM (IMERG) algorithm combines information from the GPM satellite constellation to estimate precipitation over the majority of the Earths surface.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7GlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_data:imerglatev7_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'IMERG late v07 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imerglatev7_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_data:imerglatev7_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'IMERG late v07 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imerglatev7_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7GlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_anom:imerglatev7_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'IMERG late v07 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imerglatev7_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_anom:imerglatev7_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'IMERG late v07 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imerglatev7_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7GlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_zscore:imerglatev7_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG late v07 Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imerglatev7_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_zscore:imerglatev7_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG late v07 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imerglatev7_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'IMERG late v07',
          description:
            'The Integrated Multi-satellitE Retrievals for GPM (IMERG) algorithm combines information from the GPM satellite constellation to estimate precipitation over the majority of the Earths surface.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7CamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_data:imerglatev7_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'IMERG late v07 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imerglatev7_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_data:imerglatev7_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'IMERG late v07 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imerglatev7_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7CamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_anom:imerglatev7_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'IMERG late v07 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imerglatev7_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_anom:imerglatev7_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'IMERG late v07 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imerglatev7_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imerglatev7CamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_pentad_zscore:imerglatev7_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG late v07 Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imerglatev7_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imerglatev7CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imerglatev7_global_1_monthly_zscore:imerglatev7_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG late v07 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imerglatev7_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * IMERG Final v07
         */
        {
          type: 'folder',
          title: 'IMERG final v07',
          description:
            'The Integrated Multi-satellitE Retrievals for GPM (IMERG) algorithm combines information from the GPM satellite constellation to estimate precipitation over the majority of the Earths surface.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7AfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_data:imergfinalv7_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'IMERG final v07 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imergfinalv7_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_data:imergfinalv7_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'IMERG final v07 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imergfinalv7_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7AfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_anom:imergfinalv7_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'IMERG final v07 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imergfinalv7_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_anom:imergfinalv7_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'IMERG final v07 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imergfinalv7_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7AfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_zscore:imergfinalv7_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG final v07 Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imergfinalv7_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_zscore:imergfinalv7_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG final v07 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imergfinalv7_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'IMERG final v07',
          description:
            'The Integrated Multi-satellitE Retrievals for GPM (IMERG) algorithm combines information from the GPM satellite constellation to estimate precipitation over the majority of the Earths surface.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7GlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_data:imergfinalv7_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'IMERG final v07 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imergfinalv7_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_data:imergfinalv7_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'IMERG final v07 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imergfinalv7_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7GlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_anom:imergfinalv7_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'IMERG final v07 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imergfinalv7_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_anom:imergfinalv7_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'IMERG final v07 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imergfinalv7_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7GlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_zscore:imergfinalv7_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG final v07 Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imergfinalv7_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_zscore:imergfinalv7_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG final v07 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imergfinalv7_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'IMERG final v07',
          description:
            'The Integrated Multi-satellitE Retrievals for GPM (IMERG) algorithm combines information from the GPM satellite constellation to estimate precipitation over the majority of the Earths surface.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7CamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_data:imergfinalv7_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'IMERG final v07 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imergfinalv7_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_data:imergfinalv7_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'IMERG final v07 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'imergfinalv7_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7CamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_anom:imergfinalv7_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'IMERG final v07 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imergfinalv7_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_anom:imergfinalv7_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'IMERG final v07 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'imergfinalv7_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'imergfinalv7CamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_pentad_zscore:imergfinalv7_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG final v07 Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imergfinalv7_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'imergfinalv7CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_imergfinalv7_global_1_monthly_zscore:imergfinalv7_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'IMERG final v07 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'imergfinalv7_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * Hobbins RefET
         */
        {
          type: 'folder',
          title: 'Hobbins RefET',
          description:
            'The Hobbins Reference Evapotranspiration data is global evapotranspiration product derivefrom Mike Hobbins fine resolution, ETos (short crop reference ET). The original data has been rescaledto the CHIRPS resolution of 0.05&deg; for compatibility in this EWX viewer. Detailed information on the original data creation and referencing can be found here at the <a target=\"_blank\"href="https://www.esrl.noaa.gov/psd/eddi/globalrefet/"> Global Reference ET site</a>. The data can be downloaded at the <a target=\"_blank\"href="ftp://ftp.cdc.noaa.gov/Projects/RefET/global/Gen-0/fine_resolution/data_v2/">RefET FTP site</a>. Some of the available data is preliminary and is marked, preQAQC. These data will be periodically updated as new Hobbins RefET data becomes available.<br><br>**** Please note, this dataset is experimental and open to change. ****<br><br>The Climate Hazards Center wishes to thank Mike Hobbins for his presistant efforts improving this RefET product and making it available to us.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_data:hobbins_refet_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'Hobbins RefET Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'hobbins_refet_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_data:hobbins_refet_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'Hobbins RefET Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'hobbins_refet_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_anom:hobbins_refet_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'refet_dekad_anom_raster',
                  legend: {
                    style: 'refet_dekad_anom_raster',
                    customImageURL: null,
                    title: 'Hobbins RefET Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'hobbins_refet_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_anom:hobbins_refet_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'refet_monthly_anom_raster',
                  legend: {
                    style: 'refet_monthly_anom_raster',
                    customImageURL: null,
                    title: 'Hobbins RefET Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'hobbins_refet_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_zscore:hobbins_refet_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'Hobbins RefET Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'hobbins_refet_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_zscore:hobbins_refet_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'Hobbins RefET Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'hobbins_refet_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'Hobbins RefET',
          description:
            'The Hobbins Reference Evapotranspiration data is global evapotranspiration product derivefrom Mike Hobbins fine resolution, ETos (short crop reference ET). The original data has been rescaledto the CHIRPS resolution of 0.05&deg; for compatibility in this EWX viewer. Detailed information on the original data creation and referencing can be found here at the <a target=\"_blank\"href="https://www.esrl.noaa.gov/psd/eddi/globalrefet/"> Global Reference ET site</a>. The data can be downloaded at the <a target=\"_blank\"href="ftp://ftp.cdc.noaa.gov/Projects/RefET/global/Gen-0/fine_resolution/data_v2/">RefET FTP site</a>. Some of the available data is preliminary and is marked, preQAQC. These data will be periodically updated as new Hobbins RefET data becomes available.<br><br>**** Please note, this dataset is experimental and open to change. ****<br><br>The Climate Hazards Center wishes to thank Mike Hobbins for his presistant efforts improving this RefET product and making it available to us.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_data:hobbins_refet_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'Hobbins RefET Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'hobbins_refet_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_data:hobbins_refet_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'Hobbins RefET Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'hobbins_refet_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_anom:hobbins_refet_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'refet_dekad_anom_raster',
                  legend: {
                    style: 'refet_dekad_anom_raster',
                    customImageURL: null,
                    title: 'Hobbins RefET Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'hobbins_refet_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_anom:hobbins_refet_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'refet_monthly_anom_raster',
                  legend: {
                    style: 'refet_monthly_anom_raster',
                    customImageURL: null,
                    title: 'Hobbins RefET Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'hobbins_refet_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_zscore:hobbins_refet_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'Hobbins RefET Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'hobbins_refet_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_zscore:hobbins_refet_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'Hobbins RefET Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'hobbins_refet_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'Hobbins RefET',
          description:
            'The Hobbins Reference Evapotranspiration data is global evapotranspiration product derivefrom Mike Hobbins fine resolution, ETos (short crop reference ET). The original data has been rescaledto the CHIRPS resolution of 0.05&deg; for compatibility in this EWX viewer. Detailed information on the original data creation and referencing can be found here at the <a target=\"_blank\"href="https://www.esrl.noaa.gov/psd/eddi/globalrefet/"> Global Reference ET site</a>. The data can be downloaded at the <a target=\"_blank\"href="ftp://ftp.cdc.noaa.gov/Projects/RefET/global/Gen-0/fine_resolution/data_v2/">RefET FTP site</a>. Some of the available data is preliminary and is marked, preQAQC. These data will be periodically updated as new Hobbins RefET data becomes available.<br><br>**** Please note, this dataset is experimental and open to change. ****<br><br>The Climate Hazards Center wishes to thank Mike Hobbins for his presistant efforts improving this RefET product and making it available to us.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_data:hobbins_refet_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'Hobbins RefET Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'hobbins_refet_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_data:hobbins_refet_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'Hobbins RefET Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'hobbins_refet_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_anom:hobbins_refet_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'refet_dekad_anom_raster',
                  legend: {
                    style: 'refet_dekad_anom_raster',
                    customImageURL: null,
                    title: 'Hobbins RefET Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'hobbins_refet_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_anom:hobbins_refet_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'refet_monthly_anom_raster',
                  legend: {
                    style: 'refet_monthly_anom_raster',
                    customImageURL: null,
                    title: 'Hobbins RefET Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'hobbins_refet_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'hobbinsrefetCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_dekad_zscore:hobbins_refet_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'Hobbins RefET Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'hobbins_refet_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'hobbinsrefetCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_hobbins_refet_global_1_monthly_zscore:hobbins_refet_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'Hobbins RefET Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'hobbins_refet_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * TAMSAT-3.1
         */
        {
          type: 'folder',
          title: 'TAMSAT-3.1',
          description:
            'The Tropical Applications of Meteorology using SATellite (Version 3.1) data and ground-based observations produces daily rainfall estimates for all of Africa at 4km resolution. The dataset comprises high resolution satellite-derived daily rainfall estimates for all Africa from January 1983 to near present on a pentadal (5-day) scale. Ground observations are used for calibration purposes only.<br>See <a target=\"_blank\" href="https://www.tamsat.org.uk"> TAMSAT3 web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'tamsat3p1AfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_dekad_data:tamsat3p1_africa_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'TAMSAT-3 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'tamsat3p1_africa_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'tamsat3p1AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_1_monthly_data:tamsat3p1_africa_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'TAMSAT-3 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'tamsat3p1_africa_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'tamsat3p1AfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_dekad_anom:tamsat3p1_africa_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'TAMSAT-3 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'tamsat3p1_africa_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'tamsat3p1AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_1_monthly_anom:tamsat3p1_africa_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'TAMSAT-3 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'tamsat3p1_africa_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'tamsat3p1AfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_dekad_zscore:tamsat3p1_africa_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'TAMSAT-3 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'tamsat3p1_africa_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'tamsat3p1AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_1_monthly_zscore:tamsat3p1_africa_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'TAMSAT-3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'tamsat3p1_africa_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'TAMSAT-3.1',
          description:
            'The Tropical Applications of Meteorology using SATellite (Version 3.1) data and ground-based observations produces daily rainfall estimates for all of Africa at 4km resolution. The dataset comprises high resolution satellite-derived daily rainfall estimates for all Africa from January 1983 to near present on a pentadal (5-day) scale. Ground observations are used for calibration purposes only.<br>See <a target=\"_blank\" href="https://www.tamsat.org.uk"> TAMSAT3 web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'tamsat3p1GlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_dekad_data:tamsat3p1_africa_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'TAMSAT-3 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'tamsat3p1_africa_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'tamsat3p1GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_1_monthly_data:tamsat3p1_africa_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'TAMSAT-3 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'tamsat3p1_africa_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'tamsat3p1GlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_dekad_anom:tamsat3p1_africa_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'TAMSAT-3 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'tamsat3p1_africa_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'tamsat3p1GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_1_monthly_anom:tamsat3p1_africa_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'TAMSAT-3 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'tamsat3p1_africa_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'tamsat3p1GlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_dekad_zscore:tamsat3p1_africa_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'TAMSAT-3 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'tamsat3p1_africa_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'tamsat3p1GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_tamsat3p1_africa_1_monthly_zscore:tamsat3p1_africa_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'TAMSAT-3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'tamsat3p1_africa_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * ARC2
         */
        {
          type: 'folder',
          title: 'ARC2',
          description:
            'African Rainfall Climatology, version 2, is a gridded, daily 30 year precipitation estimation dataset centered over Africa at 0.1&deg; spatial resolution. The Africa Rainfall Climatology version 2(ARC2) is a revision of the first version of the ARC and is consistent with the operational Rainfall Estimation, version 2, algorithm (RFE2). ARC2 uses inputs from two sources: 1) 3-hourly geostationaryinfrared (IR) data centered over Africa from the European Organization for the Exploitation of Meteorological Satellites (EUMETSAT) and 2) quality controlled Global Telecommunication System (GTS) gauge observations reporting 24-hour rainfall accumulations over Africa. <br>For more details see the <a  target=\"_blank\" href="https://catalog.data.gov/dataset/climate-prediction-center-cpc-africa-rainfall-climatology-version-2-0-arc2-01d37"> African Rainfall Climatology version 2 </a> web page.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'arc2AfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_dekad_data:arc2_africa_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'ARC2 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'arc2_africa_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'arc2AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_1_monthly_data:arc2_africa_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'ARC2 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'arc2_africa_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'arc2AfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_dekad_anom:arc2_africa_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'ARC2 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'arc2_africa_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'arc2AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_1_monthly_anom:arc2_africa_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'ARC2 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'arc2_africa_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'arc2AfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_dekad_zscore:arc2_africa_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ARC2 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'arc2_africa_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'arc2AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_1_monthly_zscore:arc2_africa_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ARC2 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'arc2_africa_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'ARC2',
          description:
            'African Rainfall Climatology, version 2, is a gridded, daily 30 year precipitation estimation dataset centered over Africa at 0.1&deg; spatial resolution. The Africa Rainfall Climatology version 2(ARC2) is a revision of the first version of the ARC and is consistent with the operational Rainfall Estimation, version 2, algorithm (RFE2). ARC2 uses inputs from two sources: 1) 3-hourly geostationaryinfrared (IR) data centered over Africa from the European Organization for the Exploitation of Meteorological Satellites (EUMETSAT) and 2) quality controlled Global Telecommunication System (GTS) gauge observations reporting 24-hour rainfall accumulations over Africa. <br>For more details see the <a  target=\"_blank\" href="https://catalog.data.gov/dataset/climate-prediction-center-cpc-africa-rainfall-climatology-version-2-0-arc2-01d37"> African Rainfall Climatology version 2 </a> web page.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'arc2GlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_dekad_data:arc2_africa_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'ARC2 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'arc2_africa_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'arc2GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_1_monthly_data:arc2_africa_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'ARC2 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'arc2_africa_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'arc2GlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_dekad_anom:arc2_africa_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'ARC2 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'arc2_africa_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'arc2GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_1_monthly_anom:arc2_africa_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'ARC2 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'arc2_africa_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'arc2GlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_dekad_zscore:arc2_africa_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ARC2 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'arc2_africa_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'arc2GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_arc2_africa_1_monthly_zscore:arc2_africa_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ARC2 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'arc2_africa_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * Persiann-CSS
         */
        {
          type: 'folder',
          title: 'PERSIANN-CCS',
          description:
            'The Precipitation Estimation from Remotely Sensed Information using Artificial Neural Networks - Cloud Classification System is a real-time global high resolution (0.04&deg x 0.04&deg) satellite precipitation product developed by the Center for Hydrometeorology and Remote Sensing (CHRS) at the University of California, Irvine (UCI). PERSIANN-CCS system enables the categorization of cloud-patch features based on cloud height, areal extent, and variability of texture estimated from satellite imagery. <br> See <a  target=\"_blank\"href="http://chrsdata.eng.uci.edu/"> PERSIANN-CCS web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_data:persiann-ccs_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'PERSIANN-CCS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'persiann-ccs_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_anom:persiann-ccs_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'PERSIANN-CCS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'persiann-ccs_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_zscore:persiann-ccs_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'PERSIANN-CCS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'persiann-ccs_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'PERSIANN-CCS',
          description:
            'The Precipitation Estimation from Remotely Sensed Information using Artificial Neural Networks - Cloud Classification System is a real-time global high resolution (0.04&deg x 0.04&deg) satellite precipitation product developed by the Center for Hydrometeorology and Remote Sensing (CHRS) at the University of California, Irvine (UCI). PERSIANN-CCS system enables the categorization of cloud-patch features based on cloud height, areal extent, and variability of texture estimated from satellite imagery. <br> See <a  target=\"_blank\"href="http://chrsdata.eng.uci.edu/"> PERSIANN-CCS web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_data:persiann-ccs_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'PERSIANN-CCS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'persiann-ccs_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_anom:persiann-ccs_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'PERSIANN-CCS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'persiann-ccs_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_zscore:persiann-ccs_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'PERSIANN-CCS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'persiann-ccs_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'PERSIANN-CCS',
          description:
            'The Precipitation Estimation from Remotely Sensed Information using Artificial Neural Networks - Cloud Classification System is a real-time global high resolution (0.04&deg x 0.04&deg) satellite precipitation product developed by the Center for Hydrometeorology and Remote Sensing (CHRS) at the University of California, Irvine (UCI). PERSIANN-CCS system enables the categorization of cloud-patch features based on cloud height, areal extent, and variability of texture estimated from satellite imagery. <br> See <a  target=\"_blank\"href="http://chrsdata.eng.uci.edu/"> PERSIANN-CCS web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_data:persiann-ccs_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'PERSIANN-CCS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'persiann-ccs_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_anom:persiann-ccs_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'PERSIANN-CCS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'persiann-ccs_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'persiann-ccsCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_persiann-ccs_global_1_monthly_zscore:persiann-ccs_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'PERSIANN-CCS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'persiann-ccs_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHPclim
         */
        {
          type: 'folder',
          title: 'CHPclim',
          description:
            'The Climate Hazards Groups Precipitation Climatology, version 1 is a CHIRPS compatible (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation climatology. It is the basis for CHIRPS products. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/CHPclim/"> CHPclim web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chpclimAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_dekad_data:chpclim_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHPclim Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chpclimAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_1_monthly_data:chpclim_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chpclimAfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_3_monthly_data:chpclim_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHPclim',
          description:
            'The Climate Hazards Groups Precipitation Climatology, version 1 is a CHIRPS compatible (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation climatology. It is the basis for CHIRPS products. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/CHPclim/"> CHPclim web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chpclimGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_dekad_data:chpclim_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHPclim Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chpclimGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_1_monthly_data:chpclim_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chpclimGlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_3_monthly_data:chpclim_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHPclim',
          description:
            'The Climate Hazards Groups Precipitation Climatology, version 1 is a CHIRPS compatible (50&deg; S - 50&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation climatology. It is the basis for CHIRPS products. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/CHPclim/"> CHPclim web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chpclimCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_dekad_data:chpclim_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'CHPclim Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chpclimCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_1_monthly_data:chpclim_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chpclimCamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim_global_3_monthly_data:chpclim_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHPclim 2
         */
        {
          type: 'folder',
          title: 'CHPclim2',
          description:
            'The Climate Hazards Groups Precipitation Climatology, version 2 is a CHIRPS compatible (90&deg; S - 90&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation climatology. It is the basis for CHIRPS products. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/CHPclim/"> CHPclim web page </a> for more information.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chpclim2AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim2_global_1_monthly_data:chpclim2_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim 2 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim2_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHPclim2',
          description:
            'The Climate Hazards Groups Precipitation Climatology, version 2 is a CHIRPS compatible (90&deg; S - 90&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation climatology. It is the basis for CHIRPS products. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/CHPclim/"> CHPclim web page </a> for more information.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chpclim2GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim2_global_1_monthly_data:chpclim2_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim2_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHPclim2',
          description:
            'The Climate Hazards Groups Precipitation Climatology, version 2 is a CHIRPS compatible (90&deg; S - 90&deg; N, 180&deg; E - 180&deg; W), 0.05&deg; resolution, 1981 to near-present gridded precipitation climatology. It is the basis for CHIRPS products. <br>See <a target=\"_blank\" href="http://chc.ucsb.edu/data/CHPclim/"> CHPclim web page </a> for more information.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chpclim2CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chpclim2_global_1_monthly_data:chpclim2_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHPclim Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chpclim2_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'folder',
      title: 'CHC Research (Experimental)',
      expanded:true,
      folder: [
        /*
         * CHIRPS v3.1
         */
        {
          type: 'folder',
          title: 'CHIRPS v3.1 Final',
          description:
            'Climate Hazard group InfraRed Precipitation with Stations version 3.1 time series. CHIRPSv3.1 data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Group (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_data:chirps-v3p1_test_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.1 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_anom:chirps-v3p1_test_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.1 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_zscore:chirps-v3p1_test_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.1 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.1 Final',
          description:
            'Climate Hazard group InfraRed Precipitation with Stations version 3.1 time series. CHIRPSv3.1 data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate Hazard Group (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_data:chirps-v3p1_test_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.1 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_anom:chirps-v3p1_test_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.1 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_zscore:chirps-v3p1_test_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.1 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRPS v3.1 Final',
          description:
            'Climate Hazard group InfraRed Precipitation with Stations version 3.1 time series. CHIRPSv3.1  data are produced by scientists at the University of California, Santa Barbara (UCSB) Climate HazardGroup (CHC) and the U.S. Geological Survey (USGS) Earth Resources Observation and Science (EROS) Center.',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_data:chirps-v3p1_test_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHIRPS v3.1 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_anom:chirps-v3p1_test_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHIRPS v3.1 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirpsv3p1CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirps-v3p1_test_global_1_monthly_zscore:chirps-v3p1_test_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHIRPS v3.1 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirps-v3p1_test_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTS-GEFS
         */
        {
          type: 'folder',
          title: 'CHIRTS-GEFS',
          description:
            "CHIRTS-GEFS is a product that combines the NCEP's Global Ensemble Forecast System (GEFS) 16 day temperature forecasts with the CHIRTS climatology to produce a CHIRTS compatible (latitude 70N -60S, ~0.05 degree resolution) dekadal forecasts. Temperature forecasts are produced daily and accumulated for the 5 day forecast period beginning on the date in the title bar. Version 12 (v12) incorporatesthe new GEFS forecast model v12, as of Oct. 2020, and uses the 0.5 deg (p5) resolution run for all days.",
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaData05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_data:chirts_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_05day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaData10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_data:chirts_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_10day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaData15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_data:chirts_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_15day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaAnomaly05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_anomaly:chirts_gefs_global_05day_anomaly',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_05day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaAnomaly10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_anomaly:chirts_gefs_global_10day_anomaly',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_10day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaAnomaly15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_anomaly:chirts_gefs_global_15day_anomaly',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_15day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaZscore05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_zscore:chirts_gefs_global_05day_zscore',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts_gefs_global_05day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaZscore10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_zscore:chirts_gefs_global_10day_zscore',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts_gefs_global_10day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsAfricaZscore15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_zscore:chirts_gefs_global_15day_zscore',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_15day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-GEFS',
          description:
            "CHIRTS-GEFS is a product that combines the NCEP's Global Ensemble Forecast System (GEFS) 16 day temperature forecasts with the CHIRTS climatology to produce a CHIRTS compatible (latitude 70N -60S, ~0.05 degree resolution) dekadal forecasts. Temperature forecasts are produced daily and accumulated for the 5 day forecast period beginning on the date in the title bar. Version 12 (v12) incorporatesthe new GEFS forecast model v12, as of Oct. 2020, and uses the 0.5 deg (p5) resolution run for all days.",
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalData05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_data:chirts_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_05day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalData10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_data:chirts_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_10day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalData15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_data:chirts_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_15day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalAnomaly05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_anomaly:chirts_gefs_global_05day_anomaly',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_05day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalAnomaly10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_anomaly:chirts_gefs_global_10day_anomaly',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_10day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalAnomaly15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_anomaly:chirts_gefs_global_15day_anomaly',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_15day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalZscore05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_zscore:chirts_gefs_global_05day_zscore',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts_gefs_global_05day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalZscore10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_zscore:chirts_gefs_global_10day_zscore',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts_gefs_global_10day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsGlobalZscore15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_zscore:chirts_gefs_global_15day_zscore',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_15day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-GEFS',
          description:
            "CHIRTS-GEFS is a product that combines the NCEP's Global Ensemble Forecast System (GEFS) 16 day temperature forecasts with the CHIRTS climatology to produce a CHIRTS compatible (latitude 70N -60S, ~0.05 degree resolution) dekadal forecasts. Temperature forecasts are produced daily and accumulated for the 5 day forecast period beginning on the date in the title bar. Version 12 (v12) incorporatesthe new GEFS forecast model v12, as of Oct. 2020, and uses the 0.5 deg (p5) resolution run for all days.",
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarData05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_data:chirts_gefs_global_05day_data',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_05day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarData10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_data:chirts_gefs_global_10day_data',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_10day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarData15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_data:chirts_gefs_global_15day_data',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Data (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_15day_data',
                    chartYAxisLabel: 'Temperature Forecast (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anom',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarAnomaly05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_anomaly:chirts_gefs_global_05day_anomaly',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_05day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarAnomaly10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_anomaly:chirts_gefs_global_10day_anomaly',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_10day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarAnomaly15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_anomaly:chirts_gefs_global_15day_anomaly',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Anomaly (C)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts_gefs_global_15day_anomaly',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarZscore05Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_05day_zscore:chirts_gefs_global_05day_zscore',
                  title: '05 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 05 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts_gefs_global_05day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarZscore10Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_10day_zscore:chirts_gefs_global_10day_zscore',
                  title: '10 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 10 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts_gefs_global_10day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsgefsCamcarZscore15Day',
                  isWMST: true,
                  wmstName: 'EWX_chirts_gefs_global_15day_zscore:chirts_gefs_global_15day_zscore',
                  title: '15 Day',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-GEFS 15 day Zscore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts_gefs_global_15day_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'day',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CCD-B1
         */
        {
          type: 'folder',
          title: 'CCD-B1',
          description:
            'Cold Cloud Duration',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1AfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_data:ccd-b1_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_data:ccd-b1_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRP Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_data:ccd-b1_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_data:ccd-b1_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_data:ccd-b1_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1AfricaAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_anom:ccd-b1_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_anom:ccd-b1_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_anom:ccd-b1_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_anom:ccd-b1_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_anom:ccd-b1_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1AfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_zscore:ccd-b1_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_zscore:ccd-b1_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_zscore:ccd-b1_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_zscore:ccd-b1_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1AfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_zscore:ccd-b1_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CCD-B1',
          description:
            'Cold Cloud Duration',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1GlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_data:ccd-b1_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_data:ccd-b1_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_data:ccd-b1_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_data:ccd-b1_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_data:ccd-b1_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1GlobalAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_anom:ccd-b1_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_anom:ccd-b1_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_anom:ccd-b1_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_anom:ccd-b1_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_anom:ccd-b1_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1GlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_zscore:ccd-b1_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_zscore:ccd-b1_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_zscore:ccd-b1_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_zscore:ccd-b1_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1GlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_zscore:ccd-b1_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CCD-B1',
          description:
            'Cold Cloud Duration',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1CamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_data:ccd-b1_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_data:ccd-b1_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_data:ccd-b1_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_data:ccd-b1_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_data:ccd-b1_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-B1 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1CamcarAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_anom:ccd-b1_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_anom:ccd-b1_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_anom:ccd-b1_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_anom:ccd-b1_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_anom:ccd-b1_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-B1 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-b1_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdb1CamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_pentad_zscore:ccd-b1_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-b1_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_dekad_zscore:ccd-b1_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_1_monthly_zscore:ccd-b1_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_2_monthly_zscore:ccd-b1_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdb1CamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-b1_global_3_monthly_zscore:ccd-b1_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-B1 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-b1_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CCD-CPC
         */
        {
          type: 'folder',
          title: 'CCD-CPC',
          description:
            'Cold Cloud Duration',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_data:ccd-cpc_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_data:ccd-cpc_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CHIRP Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_data:ccd-cpc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_data:ccd-cpc_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_data:ccd-cpc_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_anom:ccd-cpc_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_anom:ccd-cpc_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_anom:ccd-cpc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_anom:ccd-cpc_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_anom:ccd-cpc_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_zscore:ccd-cpc_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_zscore:ccd-cpc_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_zscore:ccd-cpc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_zscore:ccd-cpc_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcAfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_zscore:ccd-cpc_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CCD-CPC',
          description:
            'Cold Cloud Duration',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_data:ccd-cpc_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_data:ccd-cpc_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_data:ccd-cpc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_data:ccd-cpc_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_data:ccd-cpc_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_anom:ccd-cpc_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_anom:ccd-cpc_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_anom:ccd-cpc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_anom:ccd-cpc_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_anom:ccd-cpc_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_zscore:ccd-cpc_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_zscore:ccd-cpc_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_zscore:ccd-cpc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_zscore:ccd-cpc_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcGlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_zscore:ccd-cpc_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CCD-CPC',
          description:
            'Cold Cloud Duration',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_data:ccd-cpc_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_data:ccd-cpc_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Dekadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_dekad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_data:ccd-cpc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarData2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_data:ccd-cpc_global_2_monthly_data',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 2 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_2_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_data:ccd-cpc_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_data_raster',
                  legend: {
                    style: 'ccd_dekad_data_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 3 Month Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_3_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarAnomPentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_anom:ccd-cpc_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_anom:ccd-cpc_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Dekadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_dekad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_anom:ccd-cpc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarAnomaly2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_anom:ccd-cpc_global_2_monthly_anom',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 2 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_2_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_anom:ccd-cpc_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'ccd_dekad_anom_raster',
                  legend: {
                    style: 'ccd_dekad_anom_raster',
                    customImageURL: null,
                    title: 'CCD-CPC 3 Month Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'ccd-cpc_global_3_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_pentad_zscore:ccd-cpc_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Pentadal Zcore',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'ccd-cpc_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_dekad_zscore:ccd-cpc_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_dekad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_1_monthly_zscore:ccd-cpc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarZscore2Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_2_monthly_zscore:ccd-cpc_global_2_monthly_zscore',
                  title: '2-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC 2 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_2_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '2month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'ccdcpcCamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_ccd-cpc_global_3_monthly_zscore:ccd-cpc_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 4,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CCD-CPC 3 Month Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'ccd-cpc_global_3_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTS-ERA5 tmax
         */
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 Tmax',
          description:
            'Maximum Temperature',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_data:chirts-era5tmax_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_pentad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_data:chirts-era5tmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_data:chirts-era5tmax_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_anom:chirts-era5tmax_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_pentad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_anom:chirts-era5tmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_anom:chirts-era5tmax_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_zscore:chirts-era5tmax_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_pentad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_zscore:chirts-era5tmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxAfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_zscore:chirts-era5tmax_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 Tmax',
          description:
            'Maximum Temperature',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_data:chirts-era5tmax_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_pentad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_data:chirts-era5tmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_data:chirts-era5tmax_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_anom:chirts-era5tmax_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_pentad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_anom:chirts-era5tmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_anom:chirts-era5tmax_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_zscore:chirts-era5tmax_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_pentad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_zscore:chirts-era5tmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxGlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_zscore:chirts-era5tmax_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 Tmax',
          description:
            'Maximum Temperature',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_data:chirts-era5tmax_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_pentad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_data:chirts-era5tmax_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_data:chirts-era5tmax_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_anom:chirts-era5tmax_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_pentad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_anom:chirts-era5tmax_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_anom:chirts-era5tmax_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_pentad_zscore:chirts-era5tmax_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_pentad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_1_monthly_zscore:chirts-era5tmax_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5maxCamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmax_global_3_monthly_zscore:chirts-era5tmax_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmax 3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmax_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTS-ERA5 tmin
         */
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 Tmin',
          description:
            'Minimum Temperature',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_data:chirts-era5tmin_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_pentad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_data:chirts-era5tmin_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_data:chirts-era5tmin_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_anom:chirts-era5tmin_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_pentad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_anom:chirts-era5tmin_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_anom:chirts-era5tmin_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_zscore:chirts-era5tmin_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_pentad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_zscore:chirts-era5tmin_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minAfricaZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_zscore:chirts-era5tmin_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 Tmin',
          description:
            'Minimum Temperature',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_data:chirts-era5tmin_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_pentad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_data:chirts-era5tmin_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_data:chirts-era5tmin_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_anom:chirts-era5tmin_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_pentad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_anom:chirts-era5tmin_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_anom:chirts-era5tmin_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_zscore:chirts-era5tmin_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_pentad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_zscore:chirts-era5tmin_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minGlobalZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_zscore:chirts-era5tmin_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 Tmin',
          description:
            'Minimum Temperature',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_data:chirts-era5tmin_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_pentad_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_data:chirts-era5tmin_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarData3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_data:chirts-era5tmin_global_3_monthly_data',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Data (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_data',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_anom:chirts-era5tmin_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_pentad_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_anom:chirts-era5tmin_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarAnomaly3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_anom:chirts-era5tmin_global_3_monthly_anom',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Anomaly (C)',
                  },
                  unit: 'C',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_anom',
                    chartYAxisLabel: 'Temperature (C)',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_pentad_zscore:chirts-era5tmin_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_pentad_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_1_monthly_zscore:chirts-era5tmin_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5minCamcarZscore3Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5tmin_global_3_monthly_zscore:chirts-era5tmin_global_3_monthly_zscore',
                  title: '3-Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 Tmin 3 Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5tmin_global_3_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: '3month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTS-ERA5 VPD
         */
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 VPD',
          description:
            'Vapor Pressure Deficit',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_data:era5_vpd_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_vpd_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_data:era5_vpd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_vpd_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_anom:era5_vpd_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_vpd_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_anom:era5_vpd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_vpd_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_zscore:era5_vpd_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_vpd_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_zscore:era5_vpd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_vpd_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 VPD',
          description:
            'Vapor Pressure Deficit',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_data:era5_vpd_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_vpd_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_data:era5_vpd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_vpd_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_anom:era5_vpd_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_vpd_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_anom:era5_vpd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_vpd_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_zscore:era5_vpd_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_vpd_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_zscore:era5_vpd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_vpd_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 VPD',
          description:
            'Vapor Pressure Deficit',
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_data:era5_vpd_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_vpd_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_data:era5_vpd_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_data',
                  legend: {
                    style: 'vpd_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERAS VPD Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_vpd_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_anom:era5_vpd_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_vpd_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_anom:era5_vpd_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'vpd_anom',
                  legend: {
                    style: 'vpd_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_vpd_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5vpdCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_pentad_zscore:era5_vpd_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_vpd_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5vpdCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_vpd_global_1_monthly_zscore:era5_vpd_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 VPD Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_vpd_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTS-ERA5 HI
         */
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 HI',
          description:
            'Heat Index',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_data:chirts-era5hi_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_data:chirts-era5hi_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_dekad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_data:chirts-era5hi_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_anom:chirts-era5hi_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_anom:chirts-era5hi_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_dekad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_anom:chirts-era5hi_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_zscore:chirts-era5hi_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_zscore:chirts-era5hi_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_dekad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_zscore:chirts-era5hi_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 HI',
          description:
            'Heat Index',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_data:chirts-era5hi_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_data:chirts-era5hi_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_dekad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_data:chirts-era5hi_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_anom:chirts-era5hi_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_anom:chirts-era5hi_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_dekad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_anom:chirts-era5hi_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_zscore:chirts-era5hi_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_zscore:chirts-era5hi_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_dekad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_zscore:chirts-era5hi_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 HI',
          description:
            'Heat Index',
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_data:chirts-era5hi_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_data:chirts-era5hi_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_dekad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_data:chirts-era5hi_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_data',
                  legend: {
                    style: 'ir_temp_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_anom:chirts-era5hi_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_anom:chirts-era5hi_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_dekad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_anom:chirts-era5hi_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_pentad_zscore:chirts-era5hi_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_dekad_zscore:chirts-era5hi_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_dekad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'chirtsera5hiCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chirts-era5hi_global_1_monthly_zscore:chirts-era5hi_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 HI Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chirts-era5hi_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIRTS-ERA5 WBGT
         */
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 WBGT',
          description:
            'Wet Bulb Globe Temperature',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_data:wbgt_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtAfricaDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_data:wbgt_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_dekad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_data:wbgt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_anom:wbgt_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtAfricaAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_anom:wbgt_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_dekad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_anom:wbgt_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_zscore:wbgt_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtAfricaZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_zscore:wbgt_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_dekad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_zscore:wbgt_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 WBGT',
          description:
            'Wet Bulb Globe Temperature',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_data:wbgt_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtGlobalDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_data:wbgt_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_dekad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_data:wbgt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_anom:wbgt_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtGlobalAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_anom:wbgt_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_dekad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_anom:wbgt_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_zscore:wbgt_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtGlobalZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_zscore:wbgt_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_dekad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_zscore:wbgt_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIRTS-ERA5 WBGT',
          description:
            'Wet Bulb Globe Temperature',
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_data:wbgt_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_pentad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtCamcarDataDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_data:wbgt_global_dekad_data',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_dekad_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_data:wbgt_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'wbgt_data',
                  legend: {
                    style: 'wbgt_data',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Data',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'wbgt_global_1_monthly_data',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_anom:wbgt_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_pentad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtCamcarAnomalyDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_anom:wbgt_global_dekad_anom',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_dekad_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_anom:wbgt_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'ir_temp_anom',
                  legend: {
                    style: 'ir_temp_anom',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Anomaly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'wbgt_global_1_monthly_anom',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1980-Present Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'wbgtCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_pentad_zscore:wbgt_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_pentad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtCamcarZscoreDekadal',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_dekad_zscore:wbgt_global_dekad_zscore',
                  title: 'Dekadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Dekadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_dekad_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'dekad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'wbgtCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_wbgt_global_1_monthly_zscore:wbgt_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'lst_zscore_raster',
                  legend: {
                    style: 'lst_zscore_raster',
                    customImageURL: null,
                    title: 'CHIRTS-ERA5 WBGT Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'wbgt_global_1_monthly_zscore',
                    chartYAxisLabel: ' ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * ERA5 Precip
         */
        {
          type: 'folder',
          title: 'ERA5 Precipitation',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_data:era5_precip_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'ERA5 Precipitation Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_precip_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_data:era5_precip_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'ERA5 Precipitation Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_precip_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_anom:era5_precip_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'ERA5 Precipitation Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_precip_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_anom:era5_precip_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'ERA5 Precipitation Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_precip_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_zscore:era5_precip_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ERA5 Precipitation Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_precip_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_zscore:era5_precip_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ERA5 Precipitation Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_precip_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'ERA5 Precipitation',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_data:era5_precip_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'ERA5 Precipitation Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_precip_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_data:era5_precip_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'ERA5 Precipitation Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_precip_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_anom:era5_precip_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'ERA5 Precipitation Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_precip_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_anom:era5_precip_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'ERA5 Precipitation Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_precip_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_zscore:era5_precip_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ERA5 Precipitation Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_precip_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_zscore:era5_precip_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ERA5 Precipitation Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_precip_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'ERA5 Precipitation',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_data:era5_precip_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'ERA5 Precipitation Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_precip_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_data:era5_precip_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'ERA5 Precipitation Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'era5_precip_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_anom:era5_precip_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'ERA5 Precipitation Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_precip_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_anom:era5_precip_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'ERA5 Precipitation Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'era5_precip_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'era5precipCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_pentad_zscore:era5_precip_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ERA5 Precipitation Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_precip_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'era5precipCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_era5_precip_global_1_monthly_zscore:era5_precip_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'ERA5 Precipitation Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'era5_precip_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * GSMaP
         */
        {
          type: 'folder',
          title: 'GSMaP',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapAfricaDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_data:gsmap_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'GSMaP Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gsmap_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_data:gsmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'GSMaP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gsmap_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapAfricaAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_anom:gsmap_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'GSMaP Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gsmap_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_anom:gsmap_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'GSMaP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gsmap_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapAfricaZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_zscore:gsmap_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GSMaP Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gsmap_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_zscore:gsmap_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GSMaP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gsmap_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GSMaP',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapGlobalDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_data:gsmap_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'GSMaP Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gsmap_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_data:gsmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'GSMaP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gsmap_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapGlobalAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_anom:gsmap_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'GSMaP Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gsmap_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_anom:gsmap_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'GSMaP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gsmap_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapGlobalZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_zscore:gsmap_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GSMaP Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gsmap_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_zscore:gsmap_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GSMaP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gsmap_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GSMaP',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapCamcarDataPentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_data:gsmap_global_pentad_data',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_data_raster',
                  legend: {
                    style: 'precip_dekad_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_data_raster.png',
                    title: 'GSMaP Pentadal Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gsmap_global_pentad_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_data:gsmap_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'GSMaP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gsmap_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapCamcarAnomalyPentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_anom:gsmap_global_pentad_anom',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_dekad_anom_raster',
                  legend: {
                    style: 'precip_dekad_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_dekad_anom_raster.png',
                    title: 'GSMaP Pentadal Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gsmap_global_pentad_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_anom:gsmap_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'GSMaP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gsmap_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gsmapCamcarZscorePentadal',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_pentad_zscore:gsmap_global_pentad_zscore',
                  title: 'Pentadal',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GSMaP Pentadal Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gsmap_global_pentad_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'pentad',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
                {
                  type: 'layer',
                  id: 'gsmapCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gsmap_global_1_monthly_zscore:gsmap_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GSMaP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gsmap_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * GMCP
         */
        {
          type: 'folder',
          title: 'GMCP',
          description:
            'Global multi-source Merging-and-Calibration Precipitation (GMCP)',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_data:gmcp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'GMCP Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gmcp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_anom:gmcp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'GMCP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gmcp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_zscore:gmcp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GMCP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gmcp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GMCP',
          description:
            'Global multi-source Merging-and-Calibration Precipitation (GMCP)',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_data:gmcp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'GMCP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gmcp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_anom:gmcp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'GMCP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gmcp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_zscore:gmcp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GMCP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gmcp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GMCP',
          description:
            'Global multi-source Merging-and-Calibration Precipitation (GMCP)',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_data:gmcp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'GMCP Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gmcp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_anom:gmcp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'GMCP Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gmcp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gmcpCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gmcp_global_1_monthly_zscore:gmcp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'GMCP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gmcp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHGPS p25
         */
        {
          type: 'folder',
          title: 'CHGPS p25',
          description:
            'CHGPS p25',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_data:chgps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHGPS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25AfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_anom:chgps_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHGPS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chgps_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25AfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_zscore:chgps_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHGPS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chgps_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'GPCC Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25gpccstndensityAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25gpccstndensity_global_1_monthly_data:chgpsp25gpccstndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS GPCC Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25gpccstndensity_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHPS Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25chpsstndensityAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25chpsstndensity_global_1_monthly_data:chgpsp25chpsstndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS CHPS Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25chpsstndensity_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHC not GPCC Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25chcstnsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25chcstns_global_1_monthly_data:chgpsp25chcstns_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS CHC Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25chcstns_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Combined Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25stndenscombinedAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25stndenscombined_global_1_monthly_data:chgpsp25stndenscombined_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chgps_stn_count',
                  legend: {
                    style: 'chgps_stn_count',
                    customImageURL: null,
                    title: 'Combined GPCC CHPS Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25stndenscombined_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'GPCC - CHPS Difference',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25diffsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25diffs_global_1_monthly_data:chgpsp25diffs_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'climcontrast_data_raster',
                  legend: {
                    style: 'climcontrast_data_raster',
                    customImageURL: null,
                    title: 'GPCC - CHPS Difference Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25diffs_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            }
          ],
        },
        {
          type: 'folder',
          title: 'CHGPS p25',
          description:
            'CHGPS p25',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_data:chgps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHGPS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25GlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_anom:chgps_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHGPS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chgps_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25GlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_zscore:chgps_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHGPS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chgps_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'GPCC Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25gpccstndensityGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25gpccstndensity_global_1_monthly_data:chgpsp25gpccstndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS GPCC Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25gpccstndensity_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHPS Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25chpsstndensityGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25chpsstndensity_global_1_monthly_data:chgpsp25chpsstndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS CHPS Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25chpsstndensity_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHC not GPCC Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25chcstnsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25chcstns_global_1_monthly_data:chgpsp25chcstns_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS CHC Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25chcstns_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Combined Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25stndenscombinedGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25stndenscombined_global_1_monthly_data:chgpsp25stndenscombined_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chgps_stn_count',
                  legend: {
                    style: 'chgps_stn_count',
                    customImageURL: null,
                    title: 'Combined GPCC CHPS Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25stndenscombined_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'GPCC - CHPS Difference',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25diffsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25diffs_global_1_monthly_data:chgpsp25diffs_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'climcontrast_data_raster',
                  legend: {
                    style: 'climcontrast_data_raster',
                    customImageURL: null,
                    title: 'GPCC - CHPS Difference Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25diffs_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            }
          ],
        },
        {
          type: 'folder',
          title: 'CHGPS p25',
          description:
            'CHGPS p25',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_data:chgps_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_data_raster.png',
                    title: 'CHGPS Monthly Data (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgps_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25CamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_anom:chgps_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_monthly_anom_raster.png',
                    title: 'CHGPS Monthly Anomaly (mm)',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'chgps_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (1996-2025 Climatology)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25CamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgps_global_1_monthly_zscore:chgps_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: 'https://chc-ewx3.chc.ucsb.edu/images/legends/precip_zscore_raster.png',
                    title: 'CHGPS Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'chgps_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'GPCC Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25gpccstndensityCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25gpccstndensity_global_1_monthly_data:chgpsp25gpccstndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS GPCC Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25gpccstndensity_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHPS Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25chpsstndensityCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25chpsstndensity_global_1_monthly_data:chgpsp25chpsstndensity_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS CHPS Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25chpsstndensity_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'CHC not GPCC Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25chcstnsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25chcstns_global_1_monthly_data:chgpsp25chcstns_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'station_density_raster',
                  legend: {
                    style: 'station_density_raster',
                    customImageURL: null,
                    title: 'CHGPS CHC Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25chcstns_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Combined Station Density',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25stndenscombinedCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25stndenscombined_global_1_monthly_data:chgpsp25stndenscombined_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'chgps_stn_count',
                  legend: {
                    style: 'chgps_stn_count',
                    customImageURL: null,
                    title: 'Combined GPCC CHPS Station Density Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25stndenscombined_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'GPCC - CHPS Difference',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'chgpsp25diffsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chgpsp25diffs_global_1_monthly_data:chgpsp25diffs_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'climcontrast_data_raster',
                  legend: {
                    style: 'climcontrast_data_raster',
                    customImageURL: null,
                    title: 'GPCC - CHPS Difference Monthly',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chgpsp25diffs_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            }
          ],
        },

        /*
         * GPCC
         */
        {
          type: 'folder',
          title: 'GPCC-v2022',
          description:
            'Global Precipitation Climatology Centre',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_data:gpcc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gpcc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (Climatology 1981-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_anom:gpcc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gpcc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (Climatology 1981-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_zscore:gpcc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gpcc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GPCC-v2022',
          description:
            'Global Precipitation Climatology Centre',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_data:gpcc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gpcc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (Climatology 1981-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_anom:gpcc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gpcc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (Climatology 1981-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_zscore:gpcc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gpcc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GPCC-v2022',
          description:
            'Global Precipitation Climatology Centre',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_data:gpcc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gpcc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (Climatology 1981-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_anom:gpcc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gpcc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (Climatology 1981-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpccCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcc_global_1_monthly_zscore:gpcc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'GPCC Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gpcc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * GPCP v3.3
         */
        {
          type: 'folder',
          title: 'GPCP-v3.3',
          description:
            'Global Precipitation Climatology Project',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_data:gpcp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gpcp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (Climatology 1991-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_anom:gpcp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gpcp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (Climatology 1991-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_zscore:gpcp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gpcp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GPCP-v3.3',
          description:
            'Global Precipitation Climatology Project',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_data:gpcp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gpcp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (Climatology 1991-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_anom:gpcp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gpcp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (Climatology 1991-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_zscore:gpcp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gpcp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'GPCP-v3.3',
          description:
            'Global Precipitation Climatology Project',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_data:gpcp_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'gpcp_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly (Climatology 1991-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_anom:gpcp_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'gpcp_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score (Climatology 1991-2020)',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'gpcpCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_gpcp_global_1_monthly_zscore:gpcp_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'GPCP Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'gpcp_global_1_monthly_zscore',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CenTrends v3 Old Uncorrected
         */
        {
          type: 'folder',
          title: 'CenTrends v3 Old Uncorrected',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_data:centrends-v3-old-unc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Uncorrected Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncAfricaDatastns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_data_w_stns:centrends-v3-old-unc_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Data with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_anom:centrends-v3-old-unc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly with Stations',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncAfricaAnomalystns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_anom_w_stns:centrends-v3-old-unc_global_1_monthly_anom_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Anomaly with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_anom_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_zscore:centrends-v3-old-unc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CenTrends v3 Old Uncorrected',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_data:centrends-v3-old-unc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Uncorrected Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncGlobalDatastns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_data_w_stns:centrends-v3-old-unc_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Data with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_anom:centrends-v3-old-unc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly with Stations',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncGlobalAnomalystns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_anom_w_stns:centrends-v3-old-unc_global_1_monthly_anom_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Anomaly with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_anom_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_zscore:centrends-v3-old-unc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CenTrends v3 Old Uncorrected',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_data:centrends-v3-old-unc_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Uncorrected Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncCamcarDatastns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_data_w_stns:centrends-v3-old-unc_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Data with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_anom:centrends-v3-old-unc_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly with Stations',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncCamcarAnomalystns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_anom_w_stns:centrends-v3-old-unc_global_1_monthly_anom_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Anomaly with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_anom_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv3olduncCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v3-old-unc_global_1_monthly_zscore:centrends-v3-old-unc_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'CenTrends v3 Old Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'centrends-v3-old-unc_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CenTrends v2 Old
         */
        {
          type: 'folder',
          title: 'CenTrends v2 Old',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_data:centrends-v2-old_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldAfricaDatastns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_data_w_stns:centrends-v2-old_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Data with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldAfricaAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_anom:centrends-v2-old_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly with Stations',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldAfricaAnomalystns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_anom_w_stns:centrends-v2-old_global_1_monthly_anom_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Anomaly with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_anom_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldAfricaZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_zscore:centrends-v2-old_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CenTrends v2 Old',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_data:centrends-v2-old_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldGlobalDatastns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_data_w_stns:centrends-v2-old_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Data with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldGlobalAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_anom:centrends-v2-old_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly with Stations',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldGlobalAnomalystns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_anom_w_stns:centrends-v2-old_global_1_monthly_anom_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Anomaly with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_anom_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldGlobalZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_zscore:centrends-v2-old_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CenTrends v2 Old',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_data:centrends-v2-old_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldCamcarDatastns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_data_w_stns:centrends-v2-old_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Data with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldCamcarAnomaly1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_anom:centrends-v2-old_global_1_monthly_anom',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_anom_raster',
                  legend: {
                    style: 'precip_monthly_anom_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Anomaly (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_anom',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Anomaly with Stations',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldCamcarAnomalystns1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_anom_w_stns:centrends-v2-old_global_1_monthly_anom_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_anom_monthly_raster',
                  legend: {
                    style: 'rchecks_anom_monthly_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Anomaly with Stations (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'anom',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_anom_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Z-Score',
              expanded: false,
              folder: [
                {
                  type: 'layer',
                  id: 'centrendsv2oldCamcarZscore1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_centrends-v2-old_global_1_monthly_zscore:centrends-v2-old_global_1_monthly_zscore',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_zscore_raster',
                  legend: {
                    style: 'precip_zscore_raster',
                    customImageURL: null,
                    title: 'CenTrends v2 Old Monthly Z-Score',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'zscore',
                    rasterDataset: 'centrends-v2-old_global_1_monthly_zscore',
                    chartYAxisLabel: 'Temperature',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIMPS Clim 925
         */
        {
          type: 'folder',
          title: 'CHIMPS Clim 925',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data:chimps_clim_925_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925stnsAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data_w_stns:chimps_clim_925_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations HD',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925stnshdAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data_w_stnshd:chimps_clim_925_global_1_monthly_data_w_stnshd',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data_w_stnshd',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIMPS Clim 925',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data:chimps_clim_925_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925stnsGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data_w_stns:chimps_clim_925_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations HD',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925stnshdGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data_w_stnshd:chimps_clim_925_global_1_monthly_data_w_stnshd',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data_w_stnshd',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIMPS Clim 925',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data:chimps_clim_925_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925stnsCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data_w_stns:chimps_clim_925_global_1_monthly_data_w_stns',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data_w_stns',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
            {
              type: 'folder',
              title: 'Data with Stations HD',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpsclim925stnshdCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimps_clim_925_global_1_monthly_data_w_stnshd:chimps_clim_925_global_1_monthly_data_w_stnshd',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'rchecks_data_monthly_raster',
                  legend: {
                    style: 'rchecks_data_monthly_raster',
                    customImageURL: null,
                    title: 'CHIMPS Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimps_clim_925_global_1_monthly_data_w_stnshd',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * CHIMP Clim 925
         */
        {
          type: 'folder',
          title: 'CHIMP Clim 925',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpclim925AfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimp_clim_925_global_1_monthly_data:chimp_clim_925_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIMP Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimp_clim_925_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIMP Clim 925',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpclim925GlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimp_clim_925_global_1_monthly_data:chimp_clim_925_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIMP Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimp_clim_925_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'CHIMP Clim 925',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'chimpclim925CamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_chimp_clim_925_global_1_monthly_data:chimp_clim_925_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'precip_monthly_data_raster',
                  legend: {
                    style: 'precip_monthly_data_raster',
                    customImageURL: null,
                    title: 'CHIMP Clim 925 Monthly Data (mm)',
                  },
                  unit: 'mm',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'chimp_clim_925_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall (mm)',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * Legates Correction Factor
         */
        {
          type: 'folder',
          title: 'Legates Correction Factor',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'legatescorrfactorAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_legates_corrfactor_global_1_monthly_data:legates_corrfactor_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'corrfactor_data_raster',
                  legend: {
                    style: 'corrfactor_data_raster',
                    customImageURL: null,
                    title: 'Legates Correction Factor Monthly Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'legates_corrfactor_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'Legates Correction Factor',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'legatescorrfactorGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_legates_corrfactor_global_1_monthly_data:legates_corrfactor_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'corrfactor_data_raster',
                  legend: {
                    style: 'corrfactor_data_raster',
                    customImageURL: null,
                    title: 'Legates Correction Factor Monthly Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'legates_corrfactor_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'Legates Correction Factor',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'legatescorrfactorCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_legates_corrfactor_global_1_monthly_data:legates_corrfactor_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'corrfactor_data_raster',
                  legend: {
                    style: 'corrfactor_data_raster',
                    customImageURL: null,
                    title: 'Legates Correction Factor Monthly Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'legates_corrfactor_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

        /*
         * Fuchs Legates Correction Factor
         */
        {
          type: 'folder',
          title: 'Fuchs Legates Correction Factor',
          description:
            '',
          expanded: false,
          regionId: 'af',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'fuchslegatesAfricaData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_fuchs_legates_global_1_monthly_data:fuchs_legates_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'corrfactor_data_raster',
                  legend: {
                    style: 'corrfactor_data_raster',
                    customImageURL: null,
                    title: 'Fuchs Legates Correction Factor Monthly Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'fuchs_legates_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'Fuchs Legates Correction Factor',
          description:
            '',
          expanded: false,
          regionId: 'global',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'fuchslegatesGlobalData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_fuchs_legates_global_1_monthly_data:fuchs_legates_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'corrfactor_data_raster',
                  legend: {
                    style: 'corrfactor_data_raster',
                    customImageURL: null,
                    title: 'Fuchs Legates Correction Factor Monthly Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'fuchs_legates_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'folder',
          title: 'Fuchs Legates Correction Factor',
          description:
            '',
          expanded: false,
          regionId: 'camcar',
          folder: [
            {
              type: 'folder',
              title: 'Data',
              expanded: true,
              folder: [
                {
                  type: 'layer',
                  id: 'fuchslegatesCamcarData1Monthly',
                  isWMST: true,
                  wmstName: 'EWX_fuchs_legates_global_1_monthly_data:fuchs_legates_global_1_monthly_data',
                  title: 'Monthly',
                  source: {
                    wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
                    wcs: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?',
                  },
                  loadOnly: false,
                  display: false,
                  active: false,
                  mask: false,
                  zIndex: 0,
                  transparency: true,
                  srs: 'EPSG:4326',
                  resolution: '0.1',
                  featureInfo: {
                    GRAY_INDEX: {
                      displayName: 'Pixel Value',
                      displayValue: null,
                      value: null,
                      mapValues: [],
                      significantDigits: 2,
                    },
                  },
                  style: 'corrfactor_data_raster',
                  legend: {
                    style: 'corrfactor_data_raster',
                    customImageURL: null,
                    title: 'Fuchs Legates Correction Factor Monthly Data ',
                  },
                  unit: '',
                  additionalAttributes: {
                    statistic: 'data',
                    rasterDataset: 'fuchs_legates_global_1_monthly_data',
                    chartYAxisLabel: 'Rainfall ',
                  },
                  timeseries: {
                    type: 'month',
                    source: 'https://chc-ewx3.chc.ucsb.edu/api/rest/version/5.0/config',
                  },
                },
              ],
            },
          ],
        },

      ],
    },
  ],

  boundaries: [
    {
      type: 'folder',
      title: 'Boundaries',
      expanded: true,
      regionId: 'af',
      folder: [
        {
          type: 'layer',
          id: 'africaAdmin0',
          name: 'EWX_g2008_af_0:g2008_af_0',
          title: 'Countries',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: true,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'africaAdmin1',
          name: 'EWX_shapefile_g2008_af_1:shapefile_g2008_af_1',
          title: 'Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: true,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_ID: {
              displayName: 'POLY_ID',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'fews_admin_0_ngviewer',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'africaAdmin2',
          name: 'EWX_shapefile_g2008_af_2:shapefile_g2008_af_2',
          title: 'Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'fews_admin_0_ngviewer',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'africaCropzones',
          name: 'EWX_shapefile_cropzones:shapefile_cropzones',
          title: 'Crop Zones',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'FEWS_cropzone_2019',
          // legend: {
          //   style: 'FEWS_cropzone_2019',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'kenyaWards',
          name: 'EWX_shapefile_kenya_wards1:shapefile_kenya_wards1',
          title: 'Kenya Wards',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'FEWS_cropzone_2019',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'LakeVictoriaAdmin0',
          name: 'EWX_shapefile_Lake_Victoria_Basin:shapefile_Lake_Victoria_Basin',
          title: 'Lake Victoria Basin',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'TanaRiverBasinAdmin0',
          name: 'EWX_shapefile_Tana_River_Basin:shapefile_Tana_River_Basin',
          title: 'Tana River Basin',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
      ],
    },

    {
      type: 'folder',
      title: 'Boundaries',
      expanded: true,
      regionId: 'global',
      folder: [
        {
          type: 'layer',
          id: 'globalAdmin0',
          name: 'EWX_g2008_0:g2008_0',
          title: 'Global Countries',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: true,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'globalAdmin1',
          name: 'EWX_g2008_1:g2008_1',
          title: 'Global Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'globalAdmin2',
          name: 'EWX_g2008_2:g2008_2',
          title: 'Global Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM2_CODE: {
              displayName: 'ADM2_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM2_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'GAUL_2008_2',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },


        {
          type: 'layer',
          id: 'gbafricaAdmin0',
          name: 'EWX_g2008_af_0:g2008_af_0',
          title: 'African Countries',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbafricaAdmin1',
          name: 'EWX_shapefile_g2008_af_1:shapefile_g2008_af_1',
          title: 'Africa Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_ID: {
              displayName: 'POLY_ID',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'fews_admin_0_ngviewer',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbafricaAdmin2',
          name: 'EWX_shapefile_g2008_af_2:shapefile_g2008_af_2',
          title: 'Africa Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'fews_admin_0_ngviewer',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbafricaCropzones',
          name: 'EWX_shapefile_cropzones:shapefile_cropzones',
          title: 'African Crop Zones',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'FEWS_cropzone_2019',
          // legend: {
          //   style: 'FEWS_cropzone_2019',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'globalkenyaWards',
          name: 'EWX_shapefile_kenya_wards1:shapefile_kenya_wards1',
          title: 'Kenya Wards',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'FEWS_cropzone_2019',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbLakeVictoriaAdmin0',
          name: 'EWX_shapefile_Lake_Victoria_Basin:shapefile_Lake_Victoria_Basin',
          title: 'Lake Victoria Basin',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbTanaRiverBasinAdmin0',
          name: 'EWX_shapefile_Tana_River_Basin:shapefile_Tana_River_Basin',
          title: 'Tana River Basin',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },

        {
          type: 'layer',
          id: 'gbcamcarAdmin0',
          name: 'EWX_shapefile_cac14ad0_ud:shapefile_cac14ad0_ud',
          title: 'Central America and Caribbean Countries',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbcamcarAdmin1',
          name: 'EWX_shapefile_cac14ad1_ud:shapefile_cac14ad1_ud',
          title: 'Central America and Caribbean Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbcamcarAdmin2',
          name: 'EWX_shapefile_cac14ad2_ud:shapefile_cac14ad2_ud',
          title: 'Central America and Caribbean Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM2_CODE: {
              displayName: 'ADM2_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM2_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'GAUL_2008_2',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'gbcamcarCropzones',
          name: 'EWX_shapefile_cac_crops_int:shapefile_cac_crops_int',
          title: 'Central America and Caribbean Crop Zones',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'FEWS_cropzone_2019',
          // legend: {
          //   style: 'FEWS_cropzone_2019',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },

        {
          type: 'layer',
          id: 'afghanistanAdmin0',
          name: 'EWX_Afghanistan_Admin0:Afghanistan_Admin0',
          title: 'Afghanistan',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'afghanAdmin1',
          name: 'EWX_shapefile_Afghanistan_adm1:shapefile_Afghanistan_adm1',
          title: 'Afghanistan Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'afghanAdmin2',
          name: 'EWX_shapefile_Afghanistan_adm2:shapefile_Afghanistan_adm2',
          title: 'Afghanistan Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM2_CODE: {
              displayName: 'ADM2_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM2_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'GAUL_2008_2',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },

        {
          type: 'layer',
          id: 'colombiaAdmin0',
          name: 'EWX_Colombia_Admin0:Colombia_Admin0',
          title: 'Colombia',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'colombiaAdmin1',
          name: 'EWX_shapefile_Colombia_Admin1:shapefile_Colombia_Admin1',
          title: 'Colombia Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'colombiaAdmin2',
          name: 'EWX_shapefile_Colombia_Admin2:shapefile_Colombia_Admin2',
          title: 'Colombia Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM2_CODE: {
              displayName: 'ADM2_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM2_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'GAUL_2008_2',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },

        {
          type: 'layer',
          id: 'usAdmin0',
          name: 'EWX_United_States_Admin0:United_States_Admin0',
          title: 'United States of America',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'usAdmin1',
          name: 'EWX_shapefile_United_States_Admin1:shapefile_United_States_Admin1',
          title: 'United States of America Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'usAdmin2',
          name: 'EWX_shapefile_United_States_Admin2:shapefile_United_States_Admin2',
          title: 'United States of America Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM2_CODE: {
              displayName: 'ADM2_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM2_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'GAUL_2008_2',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },

        {
          type: 'layer',
          id: 'venezuelaAdmin0',
          name: 'EWX_Venezuela_Admin0:Venezuela_Admin0',
          title: 'Venezuela',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'venezuelaAdmin1',
          name: 'EWX_shapefile_Venezuela_Admin1:shapefile_Venezuela_Admin1',
          title: 'Venezuela Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'venezuelaAdmin2',
          name: 'EWX_shapefile_Venezuela_Admin2:shapefile_Venezuela_Admin2',
          title: 'Venezuela Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM2_CODE: {
              displayName: 'ADM2_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM2_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'GAUL_2008_2',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },

        {
          type: 'layer',
          id: 'yemenAdmin0',
          name: 'EWX_Yemen_Admin0:Yemen_Admin0',
          title: 'Yemen',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'yemenAdmin1',
          name: 'EWX_shapefile_yemen_adm1:shapefile_yemen_adm1',
          title: 'Yemen Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
      ],
    },

    {
      type: 'folder',
      title: 'Boundaries',
      expanded: true,
      regionId: 'camcar',
      folder: [
        {
          type: 'layer',
          id: 'camcarAdmin0',
          name: 'EWX_shapefile_cac14ad0_ud:shapefile_cac14ad0_ud',
          title: 'Countries',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: true,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_0',
          // legend: {
          //   style: 'GAUL_2008_0',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'camcarAdmin1',
          name: 'EWX_shapefile_cac14ad1_ud:shapefile_cac14ad1_ud',
          title: 'Admin 1',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: true,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM1_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_1',
          // legend: {
          //   style: 'GAUL_2008_1',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'camcarAdmin2',
          name: 'EWX_shapefile_cac14ad2_ud:shapefile_cac14ad2_ud',
          title: 'Admin 2',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM2_CODE: {
              displayName: 'ADM2_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_NAME: {
              displayName: 'ADM2_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM1_CODE: {
              displayName: 'ADM1_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            WS_START: {
              displayName: 'HEMISPHERE',
              displayValue: null,
              value: null,
              mapValues: [
                {
                  '1': 'Northern',
                },
                {
                  '7': 'Southern',
                },
              ],
            },
            GS_START: {
              displayName: 'GS_START',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'GAUL_2008_2',
          // legend: {
          //   style: 'GAUL_2008_2',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
        {
          type: 'layer',
          id: 'camcarCropzones',
          name: 'EWX_shapefile_cac_crops_int:shapefile_cac_crops_int',
          title: 'Crop Zones',
          description: '',
          source: {
            wms: 'https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?',
          },
          loadOnly: false,
          display: false,
          mask: false,
          zIndex: 0,
          srs: 'EPSG:4326',
          featureInfo: {
            ADM0_CODE: {
              displayName: 'ADM0_CODE',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            ADM0_NAME: {
              displayName: 'ADM0_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
            POLY_NAME: {
              displayName: 'POLY_NAME',
              displayValue: null,
              value: null,
              mapValues: [],
            },
          },
          style: 'FEWS_cropzone_2019',
          // legend: {
          //   style: 'FEWS_cropzone_2019',
          //   customImageURL: null,
          //   title: 'Legend Title Here',
          // },
        },
      ],
    },

  ],

  baselayers: [
    {
      type: 'folder',
      title: 'Base Layers',
      expanded: true,
      folder: [
        {
          type: 'layer',
          name: 'osm_0',
          title: 'Standard OpenStreetMap',
          description: '',
          loadOnly: false,
          display: false,
          mask: false,
          srs: 'EPSG:3857',
          loaded: 'false',
          brand: 'osm',
          source: {
            url: 'https://osm-{1-4}.gs.mil/tiles/default/{z}/{x}/{y}.png',
          },
          comments: '',
        },
        {
            "type": "layer",
            "name": "Bing Aerial",
            "title": "Bing Aerial",
            "description": "Bing Aerial",
            "loadOnly": false,
            "display": false,
            "mask": false,
            "srs": "EPSG:4326",
            "loaded": "false",
            "brand": "bing",
            "key": "Gc51rU1gAPZXqFEQTMrA~MUp98uEB4gnH03bwcMZfMQ~AofqIHvy_35WHkXHCyTAbGBfyTgycfUjPQosoS34S3HJNHOK0MFJXANeFZOiL1JC",
            "imagerySet": "AerialWithLabels",
            "comments": "imagery set values can be Road,Aerial,AerialWithLabels,collinsBart,ordnanceSurvey"
          },
          {
            "type": "layer",
            "name": "etopo:etopo30.v2",
            "title": "Elevation",
            "description": "Physical relief/altitude at 0.05 degree spatial resolution derived from Shuttle Radar Tropical Mission",
            "source": {
              "wms": "https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?",
              "wcs": "https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?",
            },
            "loadOnly": false,
            "display": false,
            "mask": false,
            "srs": "EPSG:4326",
            "style": "dem",
            "loaded": "true"
          },
          {
            "type": "layer",
            "name": "demdiegomask01:dem_diego_mask_01",
            "title": "Elevation w Diego mask",
            "description": "Physical relief/altitude at 0.05 degree spatial resolution derived from Shuttle Radar Tropical Mission with Diego's land mask applied.",
            "source": {
              "wms": "https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wms?",
              "wcs": "https://chc-ewx3.chc.ucsb.edu:8443/geoserver/wcs?",
            },
            "loadOnly": false,
            "display": false,
            "mask": false,
            "srs": "EPSG:4326",
            "style": "dem",
            "loaded": "true"
          },
      ],
    },
  ],
};
